import { Notify as be, useQuasar as pe, QForm as Ce, QInput as te, QMenu as tt, QList as ot, QItem as nt, QItemSection as at, QSelect as Xt, QBtn as X, QDialog as Ve, QPopupProxy as _t, QDate as bt, ClosePopup as Ct, QIcon as kt, QCheckbox as ye, QCard as Kt, QCardSection as Wt, Quasar as Jt, Loading as st } from "quasar";
import { computed as ue, shallowRef as Et, isRef as Me, watch as Ie, shallowReadonly as eo, toValue as ce, getCurrentScope as to, onScopeDispose as oo, readonly as St, toRef as no, customRef as ao, ref as x, reactive as we, unref as r, nextTick as rt, onMounted as ke, inject as me, openBlock as T, createElementBlock as H, createElementVNode as b, useModel as Oe, createBlock as F, withModifiers as D, withCtx as h, toDisplayString as O, createVNode as w, withKeys as ie, createSlots as xt, Fragment as Ue, renderList as it, createTextVNode as K, mergeModels as _e, useTemplateRef as ge, createCommentVNode as ne, resolveComponent as G, withDirectives as Ne, normalizeClass as qe, provide as Lt, mergeProps as Tt, TransitionGroup as Vt, resolveDirective as Pt, defineCustomElement as Ae } from "vue";
import { createI18n as so, useI18n as fe, I18nInjectionKey as Fe } from "vue-i18n";
import { parsePhoneNumberWithError as ro, parsePhoneNumberFromString as io } from "libphonenumber-js";
const lo = {
  login: {
    title: "Login or Register",
    phoneRegisterTitle: "Mobile phone number registration",
    or: "or",
    benefits: {
      birthday: "Birthday Gift",
      points: "Rewards Points",
      freeGift: "Redeem Free Gifts"
    },
    form: {
      continue: "Continue",
      labelMobile: "Mobile phone",
      labelEmailOrMobile: "E-mail or Mobile phone",
      labelEmail: "E-mail",
      validateRequired: "Please enter your email or phone number",
      validatePhone: "Please enter your correct phone number",
      validateEmail: "Please enter your correct email address",
      validateEmailRequired: "Please enter your email"
    },
    actions: {
      change: "Change",
      signIn: "Sign in",
      createAccount: "Create account",
      forgotPassword: "Forgot password"
    },
    switch: {
      codeLogin: "Verification code login",
      passwordLogin: "Password login"
    },
    code: {
      label: "Verification code",
      send: "Send",
      errorSendFail: "Failed to send verification code",
      errorSessionExpired: "The session has expired and needs to be restarted",
      errorIncorrect: "The verification code is incorrect",
      validateRequired: "Please enter the verification code",
      validateLength: "Please enter the correct verification code"
    },
    password: {
      label: "Password",
      validateRequired: "Please enter your password",
      validateLength: "Please enter a 6-digit password",
      errorIncorrect: "Password error, please re-enter"
    },
    birthday: {
      label_html: "Child's Birthday / Due Date",
      placeholder_html: "Child's Birthday / Due Date",
      validateRequired_html: "Please enter your child's birthday / due date",
      validateInvalid_html: "Please enter your current Child's Birthday / Due Date"
    },
    newsletter: {
      labelEmail: "I agree to receive notifications and updates via email",
      labelPhone: "I agree to receive notifications and updates via my phone number"
    },
    common: {
      close: "Close",
      unknownError: "Unknown error",
      confirm: "Confirm"
    },
    account: {
      existsPhone: "The phone number has been registered, please change it",
      existsEmail: "The email has been registered, please change it"
    },
    terms: {
      full: "By selecting create account you agree to our {privacy} and {terms}",
      privacy: "Privacy Policy",
      terms_html: "Terms & Conditions",
      validateRequired: "Please agree to the terms to continue",
      policyInfo: "I agree to the {privacy} and {terms} and acknowledge that providing my email and phone number is required for account management.",
      policyTip_html: "<div style='text-align:center'>Please read and agree to the Terms of Service <br>and Privacy Policy first.</div>"
    },
    country: {
      us: "United States",
      ca: "Canada"
    }
  }
}, co = {
  default: {
    ...lo,
    ...window?.__MOMCOZY_LOGIN_I18N__ || {}
  }
}, de = so({
  locale: "default",
  legacy: !1,
  escapeParameterHtml: !0,
  messages: co
}), uo = "momcozy-token";
function lt() {
  return window.__MC__CONFIG__ && window.__MC__CONFIG__.cookieName ? window.__MC__CONFIG__.cookieName : uo;
}
function fo(e) {
  const a = document.cookie.split(";").find((s) => s.trim().startsWith(`${e}=`));
  return a ? a.trim().substring(e.length + 1) : null;
}
function po(e, t, a = 7, s = window.location.hostname) {
  const i = new Date(Date.now() + a * 24 * 60 * 60 * 1e3).toUTCString();
  document.cookie = `${e}=${t}; expires=${i}; path=/; domain=${s}; SameSite=Lax`;
}
function mo(e, t = window.location.hostname) {
  document.cookie = `${e}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${t}; SameSite=Lax`;
}
function ct(e) {
  const t = lt();
  po(t, e);
}
function Be() {
  if (window.__MC__CONFIG__ && window.__MC__CONFIG__.token)
    return window.__MC__CONFIG__.token;
  const e = lt();
  return fo(e);
}
function Rt() {
  const e = lt();
  mo(e);
}
class vo extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:EXPIRED", { detail: t });
  }
}
let go = class extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:LOGIN", { detail: t });
  }
}, yo = class extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:CLOSE", { detail: t });
  }
};
class ho extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:HIDE", { detail: t });
  }
}
function $t(e) {
  document.body.classList.remove("momcozy-logined"), document.dispatchEvent(new vo(e));
}
const wo = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, _o = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, bo = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function Co(e, t) {
  if (e === "__proto__" || e === "constructor" && t && typeof t == "object" && "prototype" in t) {
    ko(e);
    return;
  }
  return t;
}
function ko(e) {
  console.warn(`[destr] Dropping "${e}" key to prevent prototype pollution.`);
}
function Eo(e, t = {}) {
  if (typeof e != "string")
    return e;
  if (e[0] === '"' && e[e.length - 1] === '"' && e.indexOf("\\") === -1)
    return e.slice(1, -1);
  const a = e.trim();
  if (a.length <= 9)
    switch (a.toLowerCase()) {
      case "true":
        return !0;
      case "false":
        return !1;
      case "undefined":
        return;
      case "null":
        return null;
      case "nan":
        return Number.NaN;
      case "infinity":
        return Number.POSITIVE_INFINITY;
      case "-infinity":
        return Number.NEGATIVE_INFINITY;
    }
  if (!bo.test(e)) {
    if (t.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return e;
  }
  try {
    if (wo.test(e) || _o.test(e)) {
      if (t.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(e, Co);
    }
    return JSON.parse(e);
  } catch (s) {
    if (t.strict)
      throw s;
    return e;
  }
}
const So = /#/g, xo = /&/g, Lo = /\//g, To = /=/g, ut = /\+/g, Vo = /%5e/gi, Po = /%60/gi, Ro = /%7c/gi, $o = /%20/gi;
function Mo(e) {
  return encodeURI("" + e).replace(Ro, "|");
}
function We(e) {
  return Mo(typeof e == "string" ? e : JSON.stringify(e)).replace(ut, "%2B").replace($o, "+").replace(So, "%23").replace(xo, "%26").replace(Po, "`").replace(Vo, "^").replace(Lo, "%2F");
}
function Ye(e) {
  return We(e).replace(To, "%3D");
}
function Mt(e = "") {
  try {
    return decodeURIComponent("" + e);
  } catch {
    return "" + e;
  }
}
function Io(e) {
  return Mt(e.replace(ut, " "));
}
function Oo(e) {
  return Mt(e.replace(ut, " "));
}
function Uo(e = "") {
  const t = /* @__PURE__ */ Object.create(null);
  e[0] === "?" && (e = e.slice(1));
  for (const a of e.split("&")) {
    const s = a.match(/([^=]+)=?(.*)/) || [];
    if (s.length < 2)
      continue;
    const i = Io(s[1]);
    if (i === "__proto__" || i === "constructor")
      continue;
    const l = Oo(s[2] || "");
    t[i] === void 0 ? t[i] = l : Array.isArray(t[i]) ? t[i].push(l) : t[i] = [t[i], l];
  }
  return t;
}
function No(e, t) {
  return (typeof t == "number" || typeof t == "boolean") && (t = String(t)), t ? Array.isArray(t) ? t.map(
    (a) => `${Ye(e)}=${We(a)}`
  ).join("&") : `${Ye(e)}=${We(t)}` : Ye(e);
}
function qo(e) {
  return Object.keys(e).filter((t) => e[t] !== void 0).map((t) => No(t, e[t])).filter(Boolean).join("&");
}
const Ao = /^[\s\w\0+.-]{2,}:([/\\]{1,2})/, Fo = /^[\s\w\0+.-]{2,}:([/\\]{2})?/, Bo = /^([/\\]\s*){2,}[^/\\]/, jo = /^\.?\//;
function It(e, t = {}) {
  return typeof t == "boolean" && (t = { acceptRelative: t }), t.strict ? Ao.test(e) : Fo.test(e) || (t.acceptRelative ? Bo.test(e) : !1);
}
function Ho(e = "", t) {
  return e.endsWith("/");
}
function Zo(e = "", t) {
  return (Ho(e) ? e.slice(0, -1) : e) || "/";
}
function Go(e = "", t) {
  return e.endsWith("/") ? e : e + "/";
}
function Do(e, t) {
  if (zo(t) || It(e))
    return e;
  const a = Zo(t);
  if (e.startsWith(a)) {
    const s = e[a.length];
    if (!s || s === "/" || s === "?")
      return e;
  }
  return Xo(a, e);
}
function Qo(e, t) {
  const a = Ko(e), s = { ...Uo(a.search), ...t };
  return a.search = qo(s), Wo(a);
}
function zo(e) {
  return !e || e === "/";
}
function Yo(e) {
  return e && e !== "/";
}
function Xo(e, ...t) {
  let a = e || "";
  for (const s of t.filter((i) => Yo(i)))
    if (a) {
      const i = s.replace(jo, "");
      a = Go(a) + i;
    } else
      a = s;
  return a;
}
const Ot = /* @__PURE__ */ Symbol.for("ufo:protocolRelative");
function Ko(e = "", t) {
  const a = e.match(
    /^[\s\0]*(blob:|data:|javascript:|vbscript:)(.*)/i
  );
  if (a) {
    const [, _, C = ""] = a;
    return {
      protocol: _.toLowerCase(),
      pathname: C,
      href: _ + C,
      auth: "",
      host: "",
      search: "",
      hash: ""
    };
  }
  if (!It(e, { acceptRelative: !0 }))
    return gt(e);
  const [, s = "", i, l = ""] = e.replace(/\\/g, "/").match(/^[\s\0]*([\w+.-]{2,}:)?\/\/([^/@]+@)?(.*)/) || [];
  let [, c = "", o = ""] = l.match(/([^#/?]*)(.*)?/) || [];
  s === "file:" && (o = o.replace(/\/(?=[A-Za-z]:)/, ""));
  const { pathname: d, search: p, hash: n } = gt(o);
  return {
    protocol: s.toLowerCase(),
    auth: i ? i.slice(0, Math.max(0, i.length - 1)) : "",
    host: c,
    pathname: d,
    search: p,
    hash: n,
    [Ot]: !s
  };
}
function gt(e = "") {
  const [t = "", a = "", s = ""] = (e.match(/([^#?]*)(\?[^#]*)?(#.*)?/) || []).splice(1);
  return {
    pathname: t,
    search: a,
    hash: s
  };
}
function Wo(e) {
  const t = e.pathname || "", a = e.search ? (e.search.startsWith("?") ? "" : "?") + e.search : "", s = e.hash || "", i = e.auth ? e.auth + "@" : "", l = e.host || "";
  return (e.protocol || e[Ot] ? (e.protocol || "") + "//" : "") + i + l + t + a + s;
}
class Jo extends Error {
  constructor(t, a) {
    super(t, a), this.name = "FetchError", a?.cause && !this.cause && (this.cause = a.cause);
  }
}
function en(e) {
  const t = e.error?.message || e.error?.toString() || "", a = e.request?.method || e.options?.method || "GET", s = e.request?.url || String(e.request) || "/", i = `[${a}] ${JSON.stringify(s)}`, l = e.response ? `${e.response.status} ${e.response.statusText}` : "<no response>", c = `${i}: ${l}${t ? ` ${t}` : ""}`, o = new Jo(
    c,
    e.error ? { cause: e.error } : void 0
  );
  for (const d of ["request", "options", "response"])
    Object.defineProperty(o, d, {
      get() {
        return e[d];
      }
    });
  for (const [d, p] of [
    ["data", "_data"],
    ["status", "status"],
    ["statusCode", "status"],
    ["statusText", "statusText"],
    ["statusMessage", "statusText"]
  ])
    Object.defineProperty(o, d, {
      get() {
        return e.response && e.response[p];
      }
    });
  return o;
}
const tn = new Set(
  Object.freeze(["PATCH", "POST", "PUT", "DELETE"])
);
function yt(e = "GET") {
  return tn.has(e.toUpperCase());
}
function on(e) {
  if (e === void 0)
    return !1;
  const t = typeof e;
  return t === "string" || t === "number" || t === "boolean" || t === null ? !0 : t !== "object" ? !1 : Array.isArray(e) ? !0 : e.buffer || e instanceof FormData || e instanceof URLSearchParams ? !1 : e.constructor && e.constructor.name === "Object" || typeof e.toJSON == "function";
}
const nn = /* @__PURE__ */ new Set([
  "image/svg",
  "application/xml",
  "application/xhtml",
  "application/html"
]), an = /^application\/(?:[\w!#$%&*.^`~-]*\+)?json(;.+)?$/i;
function sn(e = "") {
  if (!e)
    return "json";
  const t = e.split(";").shift() || "";
  return an.test(t) ? "json" : t === "text/event-stream" ? "stream" : nn.has(t) || t.startsWith("text/") ? "text" : "blob";
}
function rn(e, t, a, s) {
  const i = ln(
    t?.headers ?? e?.headers,
    a?.headers,
    s
  );
  let l;
  return (a?.query || a?.params || t?.params || t?.query) && (l = {
    ...a?.params,
    ...a?.query,
    ...t?.params,
    ...t?.query
  }), {
    ...a,
    ...t,
    query: l,
    params: l,
    headers: i
  };
}
function ln(e, t, a) {
  if (!t)
    return new a(e);
  const s = new a(t);
  if (e)
    for (const [i, l] of Symbol.iterator in e || Array.isArray(e) ? e : new a(e))
      s.set(i, l);
  return s;
}
async function Ee(e, t) {
  if (t)
    if (Array.isArray(t))
      for (const a of t)
        await a(e);
    else
      await t(e);
}
const cn = /* @__PURE__ */ new Set([
  408,
  // Request Timeout
  409,
  // Conflict
  425,
  // Too Early (Experimental)
  429,
  // Too Many Requests
  500,
  // Internal Server Error
  502,
  // Bad Gateway
  503,
  // Service Unavailable
  504
  // Gateway Timeout
]), un = /* @__PURE__ */ new Set([101, 204, 205, 304]);
function Ut(e = {}) {
  const {
    fetch: t = globalThis.fetch,
    Headers: a = globalThis.Headers,
    AbortController: s = globalThis.AbortController
  } = e;
  async function i(o) {
    const d = o.error && o.error.name === "AbortError" && !o.options.timeout || !1;
    if (o.options.retry !== !1 && !d) {
      let n;
      typeof o.options.retry == "number" ? n = o.options.retry : n = yt(o.options.method) ? 0 : 1;
      const _ = o.response && o.response.status || 500;
      if (n > 0 && (Array.isArray(o.options.retryStatusCodes) ? o.options.retryStatusCodes.includes(_) : cn.has(_))) {
        const C = typeof o.options.retryDelay == "function" ? o.options.retryDelay(o) : o.options.retryDelay || 0;
        return C > 0 && await new Promise((m) => setTimeout(m, C)), l(o.request, {
          ...o.options,
          retry: n - 1
        });
      }
    }
    const p = en(o);
    throw Error.captureStackTrace && Error.captureStackTrace(p, l), p;
  }
  const l = async function(d, p = {}) {
    const n = {
      request: d,
      options: rn(
        d,
        p,
        e.defaults,
        a
      ),
      response: void 0,
      error: void 0
    };
    if (n.options.method && (n.options.method = n.options.method.toUpperCase()), n.options.onRequest && (await Ee(n, n.options.onRequest), n.options.headers instanceof a || (n.options.headers = new a(
      n.options.headers || {}
      /* compat */
    ))), typeof n.request == "string" && (n.options.baseURL && (n.request = Do(n.request, n.options.baseURL)), n.options.query && (n.request = Qo(n.request, n.options.query), delete n.options.query), "query" in n.options && delete n.options.query, "params" in n.options && delete n.options.params), n.options.body && yt(n.options.method))
      if (on(n.options.body)) {
        const m = n.options.headers.get("content-type");
        typeof n.options.body != "string" && (n.options.body = m === "application/x-www-form-urlencoded" ? new URLSearchParams(
          n.options.body
        ).toString() : JSON.stringify(n.options.body)), m || n.options.headers.set("content-type", "application/json"), n.options.headers.has("accept") || n.options.headers.set("accept", "application/json");
      } else // ReadableStream Body
      ("pipeTo" in n.options.body && typeof n.options.body.pipeTo == "function" || // Node.js Stream Body
      typeof n.options.body.pipe == "function") && ("duplex" in n.options || (n.options.duplex = "half"));
    let _;
    if (!n.options.signal && n.options.timeout) {
      const m = new s();
      _ = setTimeout(() => {
        const y = new Error(
          "[TimeoutError]: The operation was aborted due to timeout"
        );
        y.name = "TimeoutError", y.code = 23, m.abort(y);
      }, n.options.timeout), n.options.signal = m.signal;
    }
    try {
      n.response = await t(
        n.request,
        n.options
      );
    } catch (m) {
      return n.error = m, n.options.onRequestError && await Ee(
        n,
        n.options.onRequestError
      ), await i(n);
    } finally {
      _ && clearTimeout(_);
    }
    if ((n.response.body || // https://github.com/unjs/ofetch/issues/324
    // https://github.com/unjs/ofetch/issues/294
    // https://github.com/JakeChampion/fetch/issues/1454
    n.response._bodyInit) && !un.has(n.response.status) && n.options.method !== "HEAD") {
      const m = (n.options.parseResponse ? "json" : n.options.responseType) || sn(n.response.headers.get("content-type") || "");
      switch (m) {
        case "json": {
          const y = await n.response.text(), M = n.options.parseResponse || Eo;
          n.response._data = M(y);
          break;
        }
        case "stream": {
          n.response._data = n.response.body || n.response._bodyInit;
          break;
        }
        default:
          n.response._data = await n.response[m]();
      }
    }
    return n.options.onResponse && await Ee(
      n,
      n.options.onResponse
    ), !n.options.ignoreResponseError && n.response.status >= 400 && n.response.status < 600 ? (n.options.onResponseError && await Ee(
      n,
      n.options.onResponseError
    ), await i(n)) : n.response;
  }, c = async function(d, p) {
    return (await l(d, p))._data;
  };
  return c.raw = l, c.native = (...o) => t(...o), c.create = (o = {}, d = {}) => Ut({
    ...e,
    ...d,
    defaults: {
      ...e.defaults,
      ...d.defaults,
      ...o
    }
  }), c;
}
const Pe = (function() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
})(), dn = Pe.fetch ? (...e) => Pe.fetch(...e) : () => Promise.reject(new Error("[ofetch] global.fetch is not supported!")), fn = Pe.Headers, pn = Pe.AbortController, Nt = Ut({ fetch: dn, Headers: fn, AbortController: pn }), mn = {};
function dt() {
  return window.__MC__CONFIG__ && window.__MC__CONFIG__.apiUrl ? window.__MC__CONFIG__.apiUrl : "https://account.momcozy.com";
}
function je(e) {
  const a = new TextEncoder().encode(e);
  let s = "";
  for (let i = 0; i < a.length; i++)
    s += String.fromCharCode(a[i]);
  return btoa(s);
}
function vn() {
  return window.__MC__CONFIG__ && window.__MC__CONFIG__.headers ? window.__MC__CONFIG__.headers : {
    "X-STORE-CODE": (typeof import.meta < "u" && mn && "production" || typeof process < "u" && process.env && process.env.NODE_ENV || "") === "development" ? "MOMCOZY_US_TEST" : "MOMCOZY_US"
  };
}
const gn = dt(), Re = Nt.create({
  baseURL: gn,
  onRequest({ options: e }) {
    const t = Be();
    e.headers = {
      ...e.headers,
      authorization: `Bearer ${t}`
    };
  },
  onResponse({ response: e }) {
    const t = e._data;
    t && ((t.code === "10001003" || t.code === "10001002") && $t(t), t && Reflect.has(t, "result") && (e._data = t.result));
  }
});
Re.get = (e, t) => Re(e, { method: "GET", ...t });
Re.post = (e, t) => Re(e, { method: "POST", ...t });
const ft = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/i, qt = "https://app.cozyinnov.com/app/privacy";
class yn extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:LOGIN", { detail: t });
  }
}
class hn extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:CLOSE", { detail: t });
  }
}
class $e extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:THIRD-LOGIN:SUCCESS", { detail: t });
  }
}
const wn = dt(), _n = vn(), Q = Nt.create({
  baseURL: wn,
  onRequest({ options: e }) {
    if (e.needToken) {
      const t = Be();
      t && (e.headers = {
        ...e.headers,
        authorization: `Bearer ${t}`
      });
    }
    e.headers = {
      ...e.headers,
      ..._n
    };
  },
  onResponse({ response: e }) {
    const t = e._data;
    t && ((t.code === "10001003" || t.code === "10001002") && $t(t), (t.code === "10004003" || t.code === "10004510") && be.create({
      type: "negative",
      message: t.message,
      position: "center",
      timeout: 3e3
    }), t && Object.prototype.hasOwnProperty.call(t, "result") && (e._data = t.result));
  }
});
Q.get = (e, t, a) => Q(e, { ...a, method: "GET", params: t });
Q.post = (e, t, a) => Q(e, { ...a, method: "POST", body: t });
function bn(e, t = void 0) {
  if (!e || typeof e != "string")
    return !1;
  const a = io(e, t);
  return !!a && a.isValid();
}
function Cn(e, t = void 0) {
  const a = ro(e, t);
  return {
    displayNumber: a.formatInternational(),
    number: a.number
  };
}
function At(e) {
  return Q.get("/api/station/user/getUserInfo/v2", e, { needToken: !0 });
}
function kn(e) {
  return Q.post("/api/station/user/login/preCheck", e);
}
function He(e) {
  return Q.post("/api/station/user/login/init", e);
}
function Ft(e, t = {}) {
  const a = new URLSearchParams(Object.entries(t)).toString();
  return Q.post(`/api/station/user/sendVerifyCode${a ? `?${a}` : ""}`, e);
}
function En(e) {
  return Q.post("/api/station/user/login", e);
}
function Sn(e) {
  return Q.post("/api/station/user/loginByCode", e);
}
function xn(e) {
  return Q.post("/api/station/user/checkUserAccount", e);
}
function Ln(e) {
  return Q.post("/api/station/user/verifyCode", e);
}
function Bt(e) {
  return Q.post("/api/station/user/registerByCode", e);
}
async function pt(e, t, a) {
  return await Q.post(`/api/station/user/oauth/login/${e}`, t, a);
}
async function Tn(e, t) {
  return await Q.post("/api/station/user/social/sendMailCode", e, t);
}
async function Vn(e, t) {
  return await Q.post("/api/station/user/social/verifyMailCode", e, t);
}
async function Pn(e, t) {
  return await Q.post("/api/station/user/social/verifyPass", e, t);
}
async function Rn(e, t) {
  return await Q.post("/api/station/user/quick/register", e, t);
}
async function $n(e) {
  return await Q.get("/api/station/user/get/privacyPolicy", {
    protocolType: 1,
    client: 1,
    ...e
  });
}
const Mn = /^[0-9|\-() ]+$/;
function jt(e, t) {
  const a = ue(() => ["US", "CA"].includes(t.value.country)), s = ue(() => e.value.account && a.value && Mn.test(e.value.account));
  async function i() {
    const l = s.value ? Cn(`+${e.value.areaCode.displayValue}${e.value.account}`, t.value.country) : null, c = {
      email: s.value ? "" : e.value.account,
      phone: s.value ? l.number : "",
      type: s.value ? 2 : 1
    }, o = await kn(c);
    if (!o)
      throw new Error("Pre-check failed");
    return {
      account: s.value ? l.displayNumber : e.value.account,
      realPhone: s.value ? l.number : "",
      loginType: o.nextFlow === 1 ? "login" : "register",
      loginMethod: s.value ? "phone" : "email",
      passwordType: s.value ? "code" : "password"
    };
  }
  return {
    isPhoneNum: s,
    isSupportPhoneNum: a,
    handleCheck: i
  };
}
function Je(e) {
  return to() ? (oo(e), !0) : !1;
}
const et = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const In = Object.prototype.toString, On = (e) => In.call(e) === "[object Object]", Un = () => {
};
function Nn(...e) {
  if (e.length !== 1)
    return no(...e);
  const t = e[0];
  return typeof t == "function" ? St(ao(() => ({ get: t, set: Un }))) : x(t);
}
function qn(e, t) {
  function a(...s) {
    return new Promise((i, l) => {
      Promise.resolve(e(() => t.apply(this, s), { fn: t, thisArg: this, args: s })).then(i).catch(l);
    });
  }
  return a;
}
const Ht = (e) => e();
function An(e = Ht, t = {}) {
  const {
    initialState: a = "active"
  } = t, s = Nn(a === "active");
  function i() {
    s.value = !1;
  }
  function l() {
    s.value = !0;
  }
  const c = (...o) => {
    s.value && e(...o);
  };
  return { isActive: St(s), pause: i, resume: l, eventFilter: c };
}
function Xe(e) {
  return Array.isArray(e) ? e : [e];
}
function Fn(e, t, a = {}) {
  const {
    eventFilter: s = Ht,
    ...i
  } = a;
  return Ie(
    e,
    qn(
      s,
      t
    ),
    i
  );
}
function Bn(e, t, a = {}) {
  const {
    eventFilter: s,
    initialState: i = "active",
    ...l
  } = a, { eventFilter: c, pause: o, resume: d, isActive: p } = An(s, { initialState: i });
  return { stop: Fn(
    e,
    t,
    {
      ...l,
      eventFilter: c
    }
  ), pause: o, resume: d, isActive: p };
}
function jn(e, t = 1e3, a = {}) {
  const {
    immediate: s = !0,
    immediateCallback: i = !1
  } = a;
  let l = null;
  const c = Et(!1);
  function o() {
    l && (clearInterval(l), l = null);
  }
  function d() {
    c.value = !1, o();
  }
  function p() {
    const n = ce(t);
    n <= 0 || (c.value = !0, i && e(), o(), c.value && (l = setInterval(e, n)));
  }
  if (s && et && p(), Me(t) || typeof t == "function") {
    const n = Ie(t, () => {
      c.value && et && p();
    });
    Je(n);
  }
  return Je(d), {
    isActive: eo(c),
    pause: d,
    resume: p
  };
}
function Hn(e, t, a) {
  return Ie(
    e,
    t,
    {
      ...a,
      immediate: !0
    }
  );
}
const Zt = et ? window : void 0;
function Zn(e) {
  var t;
  const a = ce(e);
  return (t = a?.$el) != null ? t : a;
}
function ht(...e) {
  const t = [], a = () => {
    t.forEach((o) => o()), t.length = 0;
  }, s = (o, d, p, n) => (o.addEventListener(d, p, n), () => o.removeEventListener(d, p, n)), i = ue(() => {
    const o = Xe(ce(e[0])).filter((d) => d != null);
    return o.every((d) => typeof d != "string") ? o : void 0;
  }), l = Hn(
    () => {
      var o, d;
      return [
        (d = (o = i.value) == null ? void 0 : o.map((p) => Zn(p))) != null ? d : [Zt].filter((p) => p != null),
        Xe(ce(i.value ? e[1] : e[0])),
        Xe(r(i.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        ce(i.value ? e[3] : e[2])
      ];
    },
    ([o, d, p, n]) => {
      if (a(), !o?.length || !d?.length || !p?.length)
        return;
      const _ = On(n) ? { ...n } : n;
      t.push(
        ...o.flatMap(
          (C) => d.flatMap(
            (m) => p.map((y) => s(C, m, y, _))
          )
        )
      );
    },
    { flush: "post" }
  ), c = () => {
    l(), a();
  };
  return Je(a), c;
}
function Gt(e, t) {
  var a, s;
  const i = Et(ce(e)), l = jn(() => {
    var n, _;
    const C = i.value - 1;
    i.value = C < 0 ? 0 : C, (n = void 0) == null || n.call(t), i.value <= 0 && (l.pause(), (_ = void 0) == null || _.call(t));
  }, (a = void 0) != null ? a : 1e3, { immediate: (s = void 0) != null ? s : !1 }), c = (n) => {
    var _;
    i.value = (_ = ce(n)) != null ? _ : ce(e);
  }, o = () => {
    l.pause(), c();
  }, d = () => {
    l.isActive.value || i.value > 0 && l.resume();
  };
  return {
    remaining: i,
    reset: c,
    stop: o,
    start: (n) => {
      c(n), l.resume();
    },
    pause: l.pause,
    resume: d,
    isActive: l.isActive
  };
}
function Gn(e = "history", t = {}) {
  const {
    initialValue: a = {},
    removeNullishValues: s = !0,
    removeFalsyValues: i = !1,
    write: l = !0,
    writeMode: c = "replace",
    window: o = Zt,
    stringify: d = (R) => R.toString()
  } = t;
  if (!o)
    return we(a);
  const p = we({});
  function n() {
    if (e === "history")
      return o.location.search || "";
    if (e === "hash") {
      const R = o.location.hash || "", k = R.indexOf("?");
      return k > 0 ? R.slice(k) : "";
    } else
      return (o.location.hash || "").replace(/^#/, "");
  }
  function _(R) {
    const k = d(R);
    if (e === "history")
      return `${k ? `?${k}` : ""}${o.location.hash || ""}`;
    if (e === "hash-params")
      return `${o.location.search || ""}${k ? `#${k}` : ""}`;
    const E = o.location.hash || "#", S = E.indexOf("?");
    return S > 0 ? `${o.location.search || ""}${E.slice(0, S)}${k ? `?${k}` : ""}` : `${o.location.search || ""}${E}${k ? `?${k}` : ""}`;
  }
  function C() {
    return new URLSearchParams(n());
  }
  function m(R) {
    const k = new Set(Object.keys(p));
    for (const E of R.keys()) {
      const S = R.getAll(E);
      p[E] = S.length > 1 ? S : R.get(E) || "", k.delete(E);
    }
    Array.from(k).forEach((E) => delete p[E]);
  }
  const { pause: y, resume: M } = Bn(
    p,
    () => {
      const R = new URLSearchParams("");
      Object.keys(p).forEach((k) => {
        const E = p[k];
        Array.isArray(E) ? E.forEach((S) => R.append(k, S)) : s && E == null || i && !E ? R.delete(k) : R.set(k, E);
      }), A(R, !1);
    },
    { deep: !0 }
  );
  function A(R, k, E = !0) {
    y(), k && m(R), c === "replace" ? o.history.replaceState(
      o.history.state,
      o.document.title,
      o.location.pathname + _(R)
    ) : E && o.history.pushState(
      o.history.state,
      o.document.title,
      o.location.pathname + _(R)
    ), rt(() => M());
  }
  function P() {
    l && A(C(), !0, !1);
  }
  const N = { passive: !0 };
  ht(o, "popstate", P, N), e !== "history" && ht(o, "hashchange", P, N);
  const j = C();
  return j.keys().next().value ? m(j) : Object.assign(p, a), p;
}
function Dt(e) {
  const t = Gn("history"), a = t.utm_medium || t.source, s = a ? `${e.value.activityType}_${a}` : e.value.activityType, i = x("");
  return ke(async () => {
    const { versionNumber: c } = await $n({ countryCode: e.value.country });
    i.value = c;
  }), ue(() => ({
    platForm: "SHOPIFY",
    registerSource: s || "",
    registerChannel: t.channel || "shopify_web",
    redirect: e.value.redirect || location.href,
    utmCampaign: t.utm_campaign || "",
    agreePrivacyVersion: i.value
  }));
}
const Ke = [
  "@gmail.com",
  "@hotmail.com",
  "@yahoo.es",
  "@hotmail.es",
  "@yahoo.com",
  "@telefonica.net",
  "@outlook.com"
];
function mt(e) {
  const t = x(!1), a = x(-1), s = ue(() => e.value.account.includes("@"));
  function i() {
    const n = e.value.account, _ = n.lastIndexOf("@");
    return _ === -1 ? "" : n.slice(_);
  }
  const l = ue(() => {
    if (!s.value)
      return [];
    const n = i();
    return n ? Ke.filter((_) => _.startsWith(n)) : Ke;
  });
  function c(n) {
    const _ = e.value.account, C = _.lastIndexOf("@"), m = _.slice(0, C);
    e.value.account = m + n;
  }
  function o(n) {
    t.value || (t.value = !0);
    const _ = l.value;
    _.length && (a.value = (a.value + n + _.length) % _.length);
  }
  function d() {
    const n = l.value;
    a.value >= 0 && a.value < n.length && c(n[a.value]);
  }
  function p(n) {
    const _ = e.value.account, C = _.lastIndexOf("@");
    if (C === -1)
      return n;
    const m = _.slice(C);
    return m ? n.replace(new RegExp(m.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i"), (y) => `<b style="color:#b27a7e">${y}</b>`) : n;
  }
  return Ie(() => e.value.account, () => {
    if (!l.value.length)
      return;
    const n = i();
    if (Ke.includes(n)) {
      t.value = !1;
      return;
    }
    t.value = !0;
  }), {
    suggestionMenu: t,
    activeSuggestionIndex: a,
    prependEmail: s,
    computedEmailOptions: l,
    selectEmailOption: c,
    moveSuggestion: o,
    applyActiveSuggestion: d,
    highlightSuggestion: p
  };
}
class he extends Error {
  constructor(t) {
    super(t), this.name = "VerificationCodeError";
  }
}
const wt = x("");
function vt(e) {
  const { t } = fe(), a = x(!1), { remaining: s, start: i } = Gt(0);
  async function l(d) {
    const p = await He({
      platForm: "SHOPIFY",
      countryCode: e.value.countryCode,
      countryName: e.value.countryName,
      redirectUrl: d
    });
    wt.value = p.sid || "";
  }
  function c(d) {
    if (!(d.status === 10 || d.status === 0))
      return d && d.status === 11 ? (l(), t("login.code.errorSessionExpired")) : d && d.status === 12 ? t("login.code.errorIncorrect") : t("login.common.unknownError");
  }
  async function o(d, p = {}) {
    if ((await xn(d)).status !== 1) {
      const C = d.type === 2 ? t("login.account.existsPhone") : t("login.account.existsEmail");
      throw new he(C);
    }
    const _ = await Ft(d, p);
    if (Reflect.has(_, "message"))
      throw new he(_.message || t("login.code.errorSendFail"));
    if (!_.codeLength)
      throw new he(c(_));
  }
  return {
    sid: wt,
    verifyCodeSending: a,
    remaining: s,
    start: i,
    sendVerificationCode: o,
    getVerifyCodeError: c,
    getInitSid: l
  };
}
const Dn = "data:image/svg+xml,%3csvg%20width='56'%20height='56'%20viewBox='0%200%2056%2056'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='28'%20cy='28'%20r='28'%20fill='%23F5F5F5'/%3e%3cg%20clip-path='url(%23clip0_4575_26415)'%3e%3cpath%20d='M40.24%2035.3791C39.7863%2036.4272%2039.2492%2037.392%2038.627%2038.279C37.7789%2039.4882%2037.0845%2040.3253%2036.5493%2040.7901C35.7197%2041.553%2034.8309%2041.9437%2033.879%2041.966C33.1957%2041.966%2032.3717%2041.7715%2031.4125%2041.3771C30.4501%2040.9845%2029.5657%2040.7901%2028.757%2040.7901C27.9089%2040.7901%2026.9993%2040.9845%2026.0263%2041.3771C25.0519%2041.7715%2024.2669%2041.9771%2023.6668%2041.9974C22.754%2042.0363%2021.8442%2041.6345%2020.9361%2040.7901C20.3565%2040.2845%2019.6315%2039.4179%2018.763%2038.1901C17.8312%2036.8791%2017.0651%2035.3587%2016.465%2033.6255C15.8222%2031.7533%2015.5%2029.9404%2015.5%2028.1853C15.5%2026.1748%2015.9344%2024.4407%2016.8046%2022.9876C17.4885%2021.8204%2018.3982%2020.8997%2019.5369%2020.2238C20.6756%2019.5479%2021.9059%2019.2035%2023.2309%2019.1815C23.9558%2019.1815%2024.9066%2019.4057%2026.088%2019.8464C27.2661%2020.2886%2028.0226%2020.5129%2028.3542%2020.5129C28.6022%2020.5129%2029.4425%2020.2507%2030.8671%2019.7279C32.2143%2019.2431%2033.3513%2019.0424%2034.2827%2019.1215C36.8067%2019.3252%2038.703%2020.3201%2039.964%2022.1127C37.7067%2023.4804%2036.5901%2025.3961%2036.6123%2027.8536C36.6327%2029.7678%2037.3271%2031.3607%2038.6919%2032.6255C39.3103%2033.2125%2040.0011%2033.6662%2040.7696%2033.9884C40.6029%2034.4717%2040.427%2034.9347%2040.24%2035.3791ZM34.4512%2012.6002C34.4512%2014.1005%2033.9031%2015.5014%2032.8106%2016.798C31.4921%2018.3394%2029.8973%2019.2302%2028.1679%2019.0896C28.1459%2018.9096%2028.1331%2018.7202%2028.1331%2018.5211C28.1331%2017.0808%2028.7601%2015.5393%2029.8736%2014.279C30.4295%2013.6409%2031.1365%2013.1103%2031.9939%2012.687C32.8494%2012.2701%2033.6587%2012.0395%2034.4198%2012C34.442%2012.2006%2034.4512%2012.4012%2034.4512%2012.6002V12.6002Z'%20fill='black'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4575_26415'%3e%3crect%20width='30'%20height='30'%20fill='white'%20transform='translate(13%2012)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", oe = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [s, i] of t)
    a[s] = i;
  return a;
}, Qn = {
  __name: "index",
  setup(e) {
    const t = pe(), a = me("config");
    function s() {
      i();
    }
    async function i() {
      t.loading.show({
        message: "loading..."
      });
      try {
        const c = await He({
          platForm: "SHOPIFY",
          countryCode: a.value.country || "US",
          countryName: a.value.countryName || "United States",
          redirectUrl: a.value.redirect || location.href,
          registerSource: a.value.activityType || "",
          registerChannel: "shopify_web"
        });
        window.localStorage.setItem(
          "apple_login_redirect",
          a.value.redirect || location.href
        );
        const o = c.sid || "", d = await pt("apple_shopify", { sid: o, redirectUri: `${location.origin}/pages/third-login-auth?channel=apple_shopify` });
        window.location.href = d;
      } catch {
        t.notify({
          type: "negative",
          message: "Login failed. Please try again."
        });
      } finally {
        t.loading.hide();
      }
    }
    async function l() {
      s();
    }
    return (c, o) => (T(), H("div", {
      class: "facebook-login",
      onClick: l
    }, [...o[0] || (o[0] = [
      b("img", {
        src: Dn,
        alt: ""
      }, null, -1)
    ])]));
  }
}, zn = /* @__PURE__ */ oe(Qn, [["__scopeId", "data-v-5191cdb9"]]), Yn = { class: "mc-login__title" }, Xn = ["innerHTML"], Kn = {
  __name: "checkForm",
  props: /* @__PURE__ */ _e({
    intelCodeList: { type: Array, default: () => [] }
  }, {
    form: {
      type: Object,
      required: !0
    },
    formModifiers: {}
  }),
  emits: /* @__PURE__ */ _e(["step"], ["update:form"]),
  setup(e, { emit: t }) {
    const a = t, s = Oe(e, "form"), { t: i } = fe(), l = me("config"), {
      suggestionMenu: c,
      activeSuggestionIndex: o,
      computedEmailOptions: d,
      selectEmailOption: p,
      moveSuggestion: n,
      applyActiveSuggestion: _,
      highlightSuggestion: C
    } = mt(s), { isPhoneNum: m, isSupportPhoneNum: y, handleCheck: M } = jt(s, l), A = ue(() => m.value ? i("login.form.labelMobile") : !s.value.account && y.value ? i("login.form.labelEmailOrMobile") : i("login.form.labelEmail"));
    function P() {
      if (!s.value.account)
        return i("login.form.validateRequired");
      if (m.value && !bn(`+1${s.value.account}`))
        return i("login.form.validatePhone");
      if (!m.value && !ft.test(s.value.account))
        return i("login.form.validateEmail");
    }
    const N = x(!1);
    async function j() {
      try {
        N.value = !0;
        const R = await M();
        a("step", R);
      } finally {
        N.value = !1;
      }
    }
    return (R, k) => (T(), F(r(Ce), {
      class: "mc-login__card mc-check",
      onSubmit: D(j, ["prevent"])
    }, {
      default: h(() => [
        b("div", Yn, O(r(i)("login.title")), 1),
        w(r(te), {
          modelValue: s.value.account,
          "onUpdate:modelValue": k[2] || (k[2] = (E) => s.value.account = E),
          autofocus: "",
          outlined: "",
          "no-error-icon": "",
          label: A.value,
          class: "item-input account-input",
          maxlength: "50",
          autocomplete: "username",
          rules: [P],
          onKeydown: [
            k[3] || (k[3] = ie(D((E) => r(n)(1), ["prevent"]), ["down"])),
            k[4] || (k[4] = ie(D((E) => r(n)(-1), ["prevent"]), ["up"])),
            ie(D(r(_), ["prevent"]), ["enter"])
          ]
        }, xt({
          default: h(() => [
            w(r(tt), {
              modelValue: r(c),
              "onUpdate:modelValue": k[1] || (k[1] = (E) => Me(c) ? c.value = E : null),
              anchor: "bottom left",
              self: "top left",
              fit: "",
              "no-parent-event": "",
              "no-focus": "",
              offset: [0, 4],
              class: "email-menu",
              cover: !1
            }, {
              default: h(() => [
                w(r(ot), { class: "email-menu__list" }, {
                  default: h(() => [
                    (T(!0), H(Ue, null, it(r(d), (E, S) => (T(), F(r(nt), {
                      key: E,
                      clickable: "",
                      dense: "",
                      active: S === r(o),
                      onMouseenter: (Z) => o.value = S,
                      onClick: (Z) => r(p)(E)
                    }, {
                      default: h(() => [
                        w(r(at), null, {
                          default: h(() => [
                            b("span", {
                              innerHTML: r(C)(E)
                            }, null, 8, Xn)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["active", "onMouseenter", "onClick"]))), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 2
        }, [
          r(m) ? {
            name: "prepend",
            fn: h(() => [
              w(r(Xt), {
                modelValue: s.value.areaCode,
                "onUpdate:modelValue": k[0] || (k[0] = (E) => s.value.areaCode = E),
                class: "area-code-select",
                outlined: "",
                options: e.intelCodeList
              }, {
                selected: h(() => [
                  b("span", null, "+ " + O(s.value.areaCode.displayValue), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["modelValue", "label", "rules", "onKeydown"]),
        w(r(X), {
          loading: N.value,
          type: "submit",
          class: "mc-login__btn"
        }, {
          default: h(() => [
            K(O(r(i)("login.form.continue")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }));
  }
}, Wn = /* @__PURE__ */ oe(Kn, [["__scopeId", "data-v-5ca98520"]]), Jn = "data:image/svg+xml,%3csvg%20width='56'%20height='56'%20viewBox='0%200%2056%2056'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='28'%20cy='28'%20r='28'%20fill='%23F5F5F5'/%3e%3cg%20clip-path='url(%23clip0_4575_26422)'%3e%3cpath%20d='M43%2028C43%2019.7158%2036.2842%2013%2028%2013C19.7158%2013%2013%2019.7158%2013%2028C13%2035.0344%2017.8432%2040.9372%2024.3766%2042.5584V32.584H21.2836V28H24.3766V26.0248C24.3766%2020.9194%2026.6872%2018.553%2031.6996%2018.553C32.65%2018.553%2034.2898%2018.7396%2034.9606%2018.9256V23.0806C34.6066%2023.0434%2033.9916%2023.0248%2033.2278%2023.0248C30.7684%2023.0248%2029.818%2023.9566%2029.818%2026.3788V28H34.7176L33.8758%2032.584H29.818V42.8902C37.2454%2041.9932%2043.0006%2035.6692%2043.0006%2028H43Z'%20fill='%230866FF'/%3e%3cpath%20d='M33.8735%2032.5857L34.7153%2028.0017H29.8157V26.3805C29.8157%2023.9583%2030.7661%2023.0265%2033.2255%2023.0265C33.9893%2023.0265%2034.6043%2023.0451%2034.9583%2023.0823V18.9273C34.2875%2018.7407%2032.6477%2018.5547%2031.6973%2018.5547C26.6849%2018.5547%2024.3743%2020.9211%2024.3743%2026.0265V28.0017H21.2812V32.5857H24.3743V42.5601C25.5347%2042.8481%2026.7485%2043.0017%2027.9977%2043.0017C28.6127%2043.0017%2029.2193%2042.9639%2029.8151%2042.8919V32.5857H33.8729H33.8735Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4575_26422'%3e%3crect%20width='30'%20height='30'%20fill='white'%20transform='translate(13%2013)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", ea = {
  __name: "index",
  setup(e) {
    const t = pe(), a = me("config");
    function s() {
      i();
    }
    async function i() {
      t.loading.show({
        message: "loading..."
      });
      try {
        const c = await He({
          platForm: "SHOPIFY",
          countryCode: a.value.country || "US",
          countryName: a.value.countryName || "United States",
          redirectUrl: a.value.redirect || location.href,
          registerSource: a.value.activityType || "",
          registerChannel: "shopify_web"
        });
        window.localStorage.setItem(
          "facebook_login_redirect",
          a.value.redirect || location.href
        );
        const o = c.sid || "", d = await pt("facebook_shopify", { sid: o, redirectUri: `${location.origin}/pages/third-login-auth?channel=facebook_shopify` });
        window.location.href = d;
      } catch {
        t.notify({
          type: "negative",
          message: "Login failed. Please try again."
        });
      } finally {
        t.loading.hide();
      }
    }
    async function l() {
      s();
    }
    return (c, o) => (T(), H("div", {
      class: "facebook-login",
      onClick: l
    }, [...o[0] || (o[0] = [
      b("img", {
        src: Jn,
        alt: ""
      }, null, -1)
    ])]));
  }
}, ta = /* @__PURE__ */ oe(ea, [["__scopeId", "data-v-bb02ab7e"]]), oa = "data:image/svg+xml,%3csvg%20width='56'%20height='56'%20viewBox='0%200%2056%2056'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='28'%20cy='28'%20r='28'%20fill='%23F5F5F5'/%3e%3cg%20clip-path='url(%23clip0_4575_26410)'%3e%3cpath%20d='M28%2025.2734V31.0825H36.0727C35.7182%2032.9507%2034.6545%2034.5326%2033.059%2035.5962L37.9272%2039.3735C40.7635%2036.7554%2042.3999%2032.9099%2042.3999%2028.3418C42.3999%2027.2782%2042.3045%2026.2553%2042.1272%2025.2736L28%2025.2734Z'%20fill='%234285F4'/%3e%3cpath%20d='M19.5938%2030.8594L18.4958%2031.6998L14.6094%2034.7271C17.0776%2039.6225%2022.1363%2043.0044%2027.9999%2043.0044C32.0498%2043.0044%2035.4452%2041.668%2037.927%2039.3771L33.0589%2035.5998C31.7225%2036.4998%2030.018%2037.0453%2027.9999%2037.0453C24.0999%2037.0453%2020.7863%2034.4135%2019.5999%2030.868L19.5938%2030.8594Z'%20fill='%2334A853'/%3e%3cpath%20d='M14.609%2021.2734C13.5863%2023.2915%2013%2025.5688%2013%2027.9961C13%2030.4233%2013.5863%2032.7006%2014.609%2034.7187C14.609%2034.7323%2019.6%2030.846%2019.6%2030.846C19.3%2029.946%2019.1226%2028.9915%2019.1226%2027.9959C19.1226%2027.0003%2019.3%2026.0458%2019.6%2025.1459L14.609%2021.2734Z'%20fill='%23FBBC05'/%3e%3cpath%20d='M28.0002%2018.9727C30.2093%2018.9727%2032.1729%2019.7363%2033.7411%2021.2091L38.0365%2016.9137C35.4319%2014.4865%2032.0502%2013%2028.0002%2013C22.1366%2013%2017.0776%2016.3682%2014.6094%2021.2773L19.6002%2025.15C20.7865%2021.6045%2024.1002%2018.9727%2028.0002%2018.9727Z'%20fill='%23EA4335'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4575_26410'%3e%3crect%20width='30'%20height='30'%20fill='white'%20transform='translate(13%2013)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", na = {
  __name: "index",
  props: {
    defaultRegion: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = pe(), a = me("config");
    let s = "";
    async function i() {
      t.loading.show({
        message: "loading..."
      });
      try {
        const l = await He({
          platForm: "SHOPIFY",
          countryCode: a.value.country || "US",
          countryName: a.value.countryName || "United States",
          redirectUrl: a.value.redirect || location.href,
          registerSource: a.value.activityType || "",
          registerChannel: "shopify_web"
        });
        window.localStorage.setItem(
          "google_login_redirect",
          a.value.redirect || location.href
        ), s = l.sid || "";
        const c = await pt("google_shopify", { sid: s, redirectUri: `${location.origin}/pages/third-login-auth?channel=google_shopify` });
        window.location.href = c;
      } catch {
        t.notify({
          type: "negative",
          message: "Login failed. Please try again."
        });
      } finally {
        t.loading.hide();
      }
    }
    return (l, c) => (T(), H("div", {
      class: "goole-login",
      onClick: i
    }, [...c[0] || (c[0] = [
      b("img", {
        src: oa,
        alt: ""
      }, null, -1)
    ])]));
  }
}, aa = /* @__PURE__ */ oe(na, [["__scopeId", "data-v-23cb802b"]]);
function Qt(e) {
  const t = x(!1);
  function a() {
    t.value || window.initGeetest4 && window.initGeetest4(
      {
        captchaId: "dfac81b336844c9273d8ab448c45c55f",
        product: "bind",
        hideSuccess: !0,
        language: "eng"
      },
      (i) => {
        t.value = i, i.onReady(() => {
        }).onSuccess(() => {
          const l = i.getValidate();
          console.log("gt4 result", l), e({
            lotNumber: l.lot_number,
            captchaOutput: l.captcha_output,
            passToken: l.pass_token,
            genTime: l.gen_time
          }), i.reset();
        }).onError(() => {
        });
      }
    );
  }
  function s() {
    t.value && t.value.showCaptcha();
  }
  return {
    initGeetest: a,
    sendGetCodeHandle: s
  };
}
const zt = `${dt()}/forget_pwd`, sa = { class: "mc-login__title" }, ra = {
  key: 0,
  class: "text-btn"
}, ia = {
  key: 0,
  class: "pwd-icon",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, la = {
  key: 1,
  class: "pwd-icon",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ca = {
  key: 2,
  class: "mc-login_switch-container"
}, ua = { class: "mc-login_setPassword" }, da = ["href"], fa = {
  __name: "loginForm",
  props: {
    form: {
      type: Object,
      required: !0
    },
    formModifiers: {}
  },
  emits: /* @__PURE__ */ _e(["step", "success"], ["update:form"]),
  setup(e, { emit: t }) {
    const a = t, s = Oe(e, "form"), { t: i } = fe(), l = me("config"), { remaining: c, start: o, reset: d } = Gt(0), p = x(!0), { sid: n, getInitSid: _, getVerifyCodeError: C } = vt(s), m = ge("verifyCodeRef"), y = x(""), M = x(!1);
    async function A(I = {}) {
      try {
        M.value = !0, await _(l.value.redirect || location.href);
        const g = await Ft(
          {
            scene: 2,
            sid: n.value,
            phone: s.value.account,
            type: 2
          },
          I
        );
        if (Reflect.has(g, "message")) {
          o(60), m.value.focus(), y.value = g.message || i("login.code.errorSendFail");
          return;
        }
        if (Reflect.has(g, "status")) {
          if (g.status === 11) {
            y.value = i("login.code.errorSessionExpired");
            return;
          } else if (g.status === 12) {
            y.value = i("login.code.errorIncorrect");
            return;
          }
        }
        o(60), m.value.focus();
      } finally {
        M.value = !1;
      }
    }
    function P() {
      a("step", {
        loginType: "",
        loginMethod: "",
        passwordType: "",
        code: "",
        password: "",
        realPhone: ""
      });
    }
    function N() {
      if (!s.value.code) {
        y.value = i("login.code.validateRequired");
        return;
      }
      if (s.value.code.length !== 6) {
        y.value = i("login.code.validateLength");
        return;
      }
      y.value = "";
    }
    function j() {
      if (!s.value.password)
        return i("login.password.validateRequired");
      if (s.value.password.length < 6)
        return i("login.password.validateLength");
    }
    const R = x(!1), k = x("");
    function E() {
      y.value = "", k.value = "", s.value.passwordType === "password" ? (s.value.passwordType = "code", d(), _(l.value.redirect || location.href)) : s.value.passwordType = "password";
    }
    async function S() {
      const I = {
        code: s.value.code,
        sid: n.value,
        phone: s.value.realPhone,
        loginType: 2,
        activityType: l.value.activityType
      }, g = await Sn(I);
      if (y.value = C(g), !y.value)
        return g;
    }
    async function Z() {
      const I = {
        platForm: "SHOPIFY",
        phone: s.value.loginMethod === "phone" ? s.value.realPhone : "",
        email: s.value.loginMethod === "email" ? s.value.account : "",
        type: s.value.loginMethod === "phone" ? 2 : 1,
        subscribeNews: s.value.subscribeNews,
        password: je(s.value.password),
        activityType: l.value.activityType,
        redirect: l.value.redirect || location.href
      }, g = await En(I);
      if (g.code === "10004013" || !g.token) {
        k.value = g.message || i("login.password.errorIncorrect");
        return;
      }
      return k.value = "", g;
    }
    async function z() {
      try {
        R.value = !0;
        let I = null;
        s.value.passwordType === "password" ? I = await Z() : I = await S(), a("success", {
          type: "login",
          email: I.email,
          token: I.token,
          shopifyLoginToken: I.shopifyLoginToken
        });
      } finally {
        R.value = !1;
      }
    }
    const { initGeetest: B, sendGetCodeHandle: W } = Qt(A);
    ke(() => {
      B();
    });
    function Y() {
      s.value.loginMethod === "phone" ? W() : A();
    }
    return (I, g) => (T(), F(r(Ce), {
      class: "mc-login__card",
      onSubmit: D(z, ["prevent"])
    }, {
      default: h(() => [
        b("div", sa, O(r(i)("login.title")), 1),
        w(r(te), {
          modelValue: s.value.account,
          "onUpdate:modelValue": g[0] || (g[0] = (U) => s.value.account = U),
          outlined: "",
          readonly: "",
          class: "item-input account-input"
        }, {
          append: h(() => [
            w(r(X), {
              class: "text-btn",
              flat: "",
              "no-caps": "",
              color: "primary",
              onClick: P
            }, {
              default: h(() => [
                K(O(r(i)("login.actions.change")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        s.value.passwordType === "code" ? (T(), F(r(te), {
          key: 0,
          ref_key: "verifyCodeRef",
          ref: m,
          modelValue: s.value.code,
          "onUpdate:modelValue": g[1] || (g[1] = (U) => s.value.code = U),
          rules: [N],
          maxlength: "6",
          "no-error-icon": "",
          type: "text",
          label: r(i)("login.code.label"),
          class: "item-input",
          outlined: "",
          "error-message": y.value,
          error: !!y.value,
          mask: "########"
        }, {
          append: h(() => [
            r(c) > 0 ? (T(), H("span", ra, O(r(c)), 1)) : (T(), F(r(X), {
              key: 1,
              class: "text-btn",
              loading: M.value,
              flat: "",
              "no-caps": "",
              color: "primary",
              onClick: Y
            }, {
              default: h(() => [
                K(O(r(i)("login.code.send")), 1)
              ]),
              _: 1
            }, 8, ["loading"]))
          ]),
          _: 1
        }, 8, ["modelValue", "rules", "label", "error-message", "error"])) : s.value.passwordType === "password" ? (T(), F(r(te), {
          key: 1,
          modelValue: s.value.password,
          "onUpdate:modelValue": [
            g[3] || (g[3] = (U) => s.value.password = U),
            g[4] || (g[4] = (U) => k.value = "")
          ],
          rules: [j],
          outlined: "",
          type: p.value ? "password" : "text",
          label: r(i)("login.password.label"),
          class: "item-input",
          "no-error-icon": "",
          autocomplete: "current-password",
          "error-message": k.value,
          error: !!k.value
        }, {
          append: h(() => [
            b("div", {
              onClick: g[2] || (g[2] = (U) => p.value = !p.value)
            }, [
              p.value ? (T(), H("svg", la, [...g[6] || (g[6] = [
                b("path", {
                  d: "M20.6523 21.2624C20.3367 21.2624 20.0289 21.1015 19.8548 20.8115L17.9992 17.7155C17.7354 17.2752 17.8786 16.7052 18.3186 16.4409C18.7586 16.1771 19.3289 16.3205 19.5926 16.7602L21.4482 19.8562C21.712 20.2965 21.5689 20.8665 21.1289 21.1309C20.9849 21.2171 20.8201 21.2626 20.6523 21.2624ZM25.6001 18.1665C25.3623 18.1665 25.1245 18.0759 24.9432 17.8943L22.4689 15.4174C22.1064 15.054 22.1067 14.4662 22.4695 14.1034C22.8323 13.7418 23.4201 13.7412 23.7829 14.104L26.2573 16.5809C26.6198 16.9443 26.6195 17.5321 26.2567 17.8949C26.1705 17.9811 26.0681 18.0495 25.9555 18.0961C25.8428 18.1427 25.722 18.1666 25.6001 18.1665ZM11.3526 21.2624C11.1901 21.2624 11.0254 21.2202 10.8761 21.1299C10.4357 20.8662 10.2932 20.2962 10.5567 19.8559L12.4123 16.7599C12.6761 16.3202 13.2464 16.1765 13.6864 16.4412C14.1267 16.7049 14.2692 17.2749 14.0057 17.7152L12.1501 20.8112C11.9761 21.1015 11.6682 21.2624 11.3526 21.2624ZM6.40512 18.1665C6.16762 18.1665 5.93012 18.0759 5.74887 17.8949C5.38605 17.5321 5.38574 16.9443 5.74824 16.5809L8.22262 14.104C8.58543 13.7412 9.17324 13.7418 9.53606 14.1034C9.89887 14.4662 9.89918 15.054 9.53668 15.4174L7.0623 17.8943C6.88074 18.0759 6.64293 18.1665 6.40512 18.1665Z",
                  fill: "black"
                }, null, -1),
                b("path", {
                  d: "M16.301 17.5478C13.7129 17.5478 9.90541 16.6612 6.46072 12.4375C6.42103 12.3884 6.39041 12.3503 6.36791 12.3244C6.02728 11.9862 5.99822 11.4378 6.31353 11.0653C6.64478 10.6734 7.23072 10.625 7.62228 10.9559C7.66166 10.989 7.7601 11.0912 7.90041 11.2631C10.8838 14.9222 14.1154 15.69 16.301 15.69C20.0726 15.69 24.3657 11.7959 24.7892 11.1772C25.0729 10.764 25.6438 10.6306 26.0673 10.9009C26.4898 11.1706 26.6342 11.7075 26.3788 12.1387C25.9395 12.88 21.1051 17.5478 16.301 17.5478Z",
                  fill: "black"
                }, null, -1)
              ])])) : (T(), H("svg", ia, [...g[5] || (g[5] = [
                b("path", {
                  d: "M15.9975 26C11.1085 26 6.74683 22.9147 2.92217 16.8873C2.75359 16.6221 2.66406 16.3143 2.66406 16C2.66406 15.6857 2.75359 15.3779 2.92217 15.1127C6.74683 9.08533 11.1085 6 15.9975 6C20.8865 6 25.2482 9.08533 29.0728 15.1127C29.2414 15.3779 29.3309 15.6857 29.3309 16C29.3309 16.3143 29.2414 16.6221 29.0728 16.8873C25.2482 22.9147 20.8865 26 15.9975 26ZM15.9975 8C11.9502 8 8.20183 10.6203 4.74383 16C8.20183 21.3797 11.9502 24 15.9975 24C20.0448 24 23.7932 21.3797 27.2512 16C23.7932 10.6203 20.0448 8 15.9975 8ZM15.9975 20.6667C13.3972 20.6667 11.2892 18.5773 11.2892 16C11.2892 13.4227 13.3972 11.3333 15.9975 11.3333C18.5978 11.3333 20.7058 13.4227 20.7058 16C20.7058 18.5773 18.5978 20.6667 15.9975 20.6667ZM15.9975 18.6667C17.4835 18.6667 18.6882 17.4727 18.6882 16C18.6882 14.5273 17.4835 13.3333 15.9975 13.3333C14.5115 13.3333 13.3068 14.5273 13.3068 16C13.3068 17.4727 14.5115 18.6667 15.9975 18.6667Z",
                  fill: "black"
                }, null, -1)
              ])]))
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "rules", "type", "label", "error-message", "error"])) : ne("", !0),
        s.value.loginMethod === "phone" ? (T(), H("div", ca, [
          b("button", {
            type: "button",
            class: "mc-login_switch",
            onClick: E
          }, O(s.value.passwordType === "password" ? r(i)("login.switch.codeLogin") : r(i)("login.switch.passwordLogin")), 1)
        ])) : ne("", !0),
        w(r(X), {
          loading: R.value,
          type: "submit",
          class: "mc-login__btn"
        }, {
          default: h(() => [
            K(O(r(i)("login.actions.signIn")), 1)
          ]),
          _: 1
        }, 8, ["loading"]),
        b("div", ua, [
          b("a", {
            href: r(zt),
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": "forget password (opens in a new tab)",
            "aria-describedby": "a11y-new-window-message"
          }, O(r(i)("login.actions.forgotPassword")), 9, da)
        ])
      ]),
      _: 1
    }));
  }
}, pa = /* @__PURE__ */ oe(fa, [["__scopeId", "data-v-6b85d1ff"]]), ma = { class: "mc-login__container register-container" }, va = { class: "title" }, ga = ["innerHTML"], ya = {
  key: 0,
  class: "text-btn"
}, ha = {
  __name: "verifyEmailWhenPhone",
  props: {
    data: {
      type: Object
    },
    registerInfo: {
      type: Object,
      required: !0
    }
  },
  emits: ["success"],
  setup(e, { expose: t, emit: a }) {
    const s = e, i = a, { t: l } = fe(), c = x(!1), o = x({
      account: "",
      code: "",
      areaCode: s.data.areaCode
    }), {
      suggestionMenu: d,
      activeSuggestionIndex: p,
      computedEmailOptions: n,
      selectEmailOption: _,
      moveSuggestion: C,
      applyActiveSuggestion: m,
      highlightSuggestion: y
    } = mt(o);
    function M() {
      if (!o.value.account)
        return l("login.form.validateEmailRequired");
      if (!ft.test(o.value.account))
        return l("login.form.validateEmail");
    }
    const A = ge("verifyCodeRef"), P = x("");
    function N() {
      if (!o.value.code) {
        P.value = l("login.code.validateRequired");
        return;
      }
      if (o.value.code.length !== 6) {
        P.value = l("login.code.validateLength");
        return;
      }
      P.value = "";
    }
    const {
      sid: j,
      verifyCodeSending: R,
      remaining: k,
      start: E,
      sendVerificationCode: S,
      getVerifyCodeError: Z
    } = vt(o);
    async function z() {
      try {
        R.value = !0;
        const I = {
          scene: 1,
          sid: j.value,
          email: o.value.account,
          type: 1
        };
        await S(I), o.value.code = "", P.value = "", rt(() => A.value.resetValidation()), E(60), A.value.focus();
      } catch (I) {
        I instanceof he ? P.value = I.message : P.value = l("login.common.unknownError");
      } finally {
        R.value = !1;
      }
    }
    const B = x(!1);
    async function W() {
      try {
        B.value = !0;
        const I = {
          registerType: 2,
          subscribeNews: s.data.subscribeNews,
          firstName: "",
          lastName: "",
          phone: s.data.account,
          email: o.value.account,
          password: je(s.data.password),
          babyBirthday: s.data.babyBirthday,
          sid: j.value,
          code: o.value.code,
          ...s.registerInfo
        }, g = await Bt(I);
        if (P.value = Z(g), B.value = !1, P.value)
          return;
        i("success", {
          type: "register",
          email: g.email,
          token: g.token,
          shopifyLoginToken: g.shopifyLoginToken
        });
      } catch {
        P.value = l("login.common.unknownError");
      }
    }
    function Y() {
      c.value = !1;
    }
    return t({
      open() {
        c.value = !0;
      }
    }), (I, g) => (T(), F(r(Ve), {
      modelValue: c.value,
      "onUpdate:modelValue": g[5] || (g[5] = (U) => c.value = U),
      class: "mc-login nt",
      persistent: ""
    }, {
      default: h(() => [
        b("div", ma, [
          w(r(X), {
            class: "mc-close-icon",
            icon: "close",
            flat: "",
            round: "",
            dense: "",
            onClick: Y
          }),
          b("div", va, O(r(l)("login.phoneRegisterTitle")), 1),
          w(r(Ce), { onSubmit: W }, {
            default: h(() => [
              w(r(te), {
                modelValue: o.value.account,
                "onUpdate:modelValue": g[1] || (g[1] = (U) => o.value.account = U),
                rules: [M],
                label: r(l)("login.form.labelEmail"),
                outlined: "",
                autofocus: "",
                "no-error-icon": "",
                class: "item-input account-input",
                maxlength: "50",
                autocomplete: "username",
                onKeydown: [
                  g[2] || (g[2] = ie(D((U) => r(C)(1), ["prevent"]), ["down"])),
                  g[3] || (g[3] = ie(D((U) => r(C)(-1), ["prevent"]), ["up"])),
                  ie(D(r(m), ["prevent"]), ["enter"])
                ]
              }, {
                default: h(() => [
                  w(r(tt), {
                    modelValue: r(d),
                    "onUpdate:modelValue": g[0] || (g[0] = (U) => Me(d) ? d.value = U : null),
                    anchor: "bottom left",
                    self: "top left",
                    fit: "",
                    "no-parent-event": "",
                    "no-focus": "",
                    offset: [0, 4],
                    class: "email-menu",
                    cover: !1
                  }, {
                    default: h(() => [
                      w(r(ot), { class: "email-menu__list" }, {
                        default: h(() => [
                          (T(!0), H(Ue, null, it(r(n), (U, q) => (T(), F(r(nt), {
                            key: U,
                            clickable: "",
                            dense: "",
                            active: q === r(p),
                            onMouseenter: (J) => p.value = q,
                            onClick: (J) => r(_)(U)
                          }, {
                            default: h(() => [
                              w(r(at), null, {
                                default: h(() => [
                                  b("span", {
                                    innerHTML: r(y)(U)
                                  }, null, 8, ga)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["active", "onMouseenter", "onClick"]))), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue", "rules", "label", "onKeydown"]),
              w(r(te), {
                ref_key: "verifyCodeRef",
                ref: A,
                modelValue: o.value.code,
                "onUpdate:modelValue": g[4] || (g[4] = (U) => o.value.code = U),
                rules: [N],
                maxlength: "6",
                "no-error-icon": "",
                type: "text",
                label: r(l)("login.code.label"),
                class: "item-input",
                outlined: "",
                "error-message": P.value,
                error: !!P.value,
                autocomplete: "one-time-code",
                mask: "########"
              }, {
                append: h(() => [
                  r(k) > 0 ? (T(), H("span", ya, O(r(k)), 1)) : (T(), F(r(X), {
                    key: 1,
                    class: "text-btn",
                    loading: r(R),
                    flat: "",
                    "no-caps": "",
                    color: "primary",
                    onClick: z
                  }, {
                    default: h(() => [
                      K(O(r(l)("login.code.send")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                ]),
                _: 1
              }, 8, ["modelValue", "rules", "label", "error-message", "error"]),
              w(r(X), {
                type: "submit",
                loading: B.value,
                class: "mc-login__btn"
              }, {
                default: h(() => [
                  K(O(r(l)("login.common.confirm")), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}, wa = /* @__PURE__ */ oe(ha, [["__scopeId", "data-v-43a81e89"]]), _a = { class: "mc-register-login__title" }, ba = {
  key: 0,
  class: "text-btn"
}, Ca = {
  key: 0,
  class: "pwd-icon",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ka = {
  key: 1,
  class: "pwd-icon",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ea = { class: "row items-center justify-end" }, Sa = { class: "mc-register__terms" }, xa = ["href"], La = {
  __name: "registerForm",
  props: {
    form: {
      type: Object,
      required: !0
    },
    formModifiers: {}
  },
  emits: /* @__PURE__ */ _e(["step", "success"], ["update:form"]),
  setup(e, { emit: t }) {
    const a = t, s = pe(), i = Ct, l = me("config", {}), { t: c } = fe(), o = Oe(e, "form"), d = Dt(l), p = ge("verifyCodeRef"), n = x(""), {
      sid: _,
      verifyCodeSending: C,
      remaining: m,
      start: y,
      sendVerificationCode: M,
      getVerifyCodeError: A,
      getInitSid: P
    } = vt(o);
    async function N(f = {}) {
      try {
        C.value = !0, await P(d.value.redirect);
        const v = {
          scene: 1,
          sid: _.value,
          phone: o.value.loginMethod === "phone" ? o.value.realPhone : "",
          email: o.value.loginMethod === "email" ? o.value.account : "",
          type: o.value.loginMethod === "phone" ? 2 : 1
        };
        await M(v, f), o.value.code = "", n.value = "", rt(() => {
          p.value.resetValidation();
        }), y(60), p.value.focus();
      } catch (v) {
        y(60), p.value.focus(), v instanceof he ? n.value = v.message : n.value = c("login.common.unknownError");
      } finally {
        C.value = !1;
      }
    }
    function j() {
      a("step", {
        loginType: "",
        loginMethod: "",
        code: "",
        password: "",
        realPhone: ""
      });
    }
    function R() {
      if (!o.value.code) {
        n.value = c("login.code.validateRequired");
        return;
      }
      if (o.value.code.length !== 6) {
        n.value = c("login.code.validateLength");
        return;
      }
      n.value = "";
    }
    const k = x(!0);
    function E() {
      if (!o.value.password)
        return c("login.password.validateRequired");
      if (o.value.password.length < 6)
        return c("login.password.validateLength");
    }
    const S = /^(?:\d{3}[1-9]|\d{2}[1-9]\d|\d[1-9]\d{2}|[1-9]\d{3})-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|02-(?:0[1-9]|1\d|2[0-8]))|(?:\d{2}(?:0[48]|[2468][048]|[13579][26])|(?:0[48]|[2468][048]|[3579][26])00)-02-29$/;
    function Z() {
      if (!o.value.babyBirthday)
        return c("login.birthday.validateRequired_html");
      if (!S.test(o.value.babyBirthday))
        return c("login.birthday.validateInvalid_html");
    }
    const z = ge("verifyEmailWhenPhoneRef"), B = x(!1);
    async function W() {
      const f = {
        phone: o.value.account,
        code: o.value.code,
        sid: _.value,
        scene: 1,
        type: 2
      }, v = await Ln(f);
      n.value = A(v), !n.value && z.value.open();
    }
    async function Y() {
      try {
        const f = {
          registerType: 1,
          subscribeNews: o.value.subscribeNews,
          firstName: "",
          lastName: "",
          email: o.value.account,
          password: je(o.value.password),
          babyBirthday: o.value.babyBirthday,
          sid: _.value,
          code: o.value.code,
          ...d.value
        }, v = await Bt(f);
        if (n.value = A(v), n.value)
          return;
        a("success", {
          type: "register",
          email: v.email,
          token: v.token,
          shopifyLoginToken: v.shopifyLoginToken
        });
      } catch {
        n.value = c("login.common.unknownError");
      }
    }
    const I = ge("policyRef");
    function g(f) {
      f.animate(
        {
          transform: [
            "translateX(0)",
            "translateX(-32px)",
            "translateX(32px)",
            "translateX(-16px)",
            "translateX(16px)",
            "translateX(-8px)",
            "translateX(8px)",
            "translateX(-4px)",
            "translateX(4px)",
            "translateX(-2px)",
            "translateX(2px)",
            "translateX(0)"
          ]
        },
        {
          duration: 1e3,
          easing: "cubic-bezier(.36, .07, .19, .97)",
          fill: "forwards"
        }
      );
    }
    const U = x(!1);
    function q() {
      U.value = !0, g(I.value);
    }
    function J(f) {
      a("success", f);
    }
    function ae() {
      return o.value.agreePolicy ? !0 : (s.notify({
        message: c("login.terms.policyTip_html"),
        position: "center",
        classes: "mc-notify--policy",
        multiLine: !0,
        html: !0,
        timeout: 2e3
      }), !1);
    }
    async function Ge() {
      try {
        if (!ae()) {
          q();
          return;
        }
        B.value = !0, o.value.loginMethod === "phone" ? await W() : await Y();
      } finally {
        B.value = !1;
      }
    }
    const { initGeetest: De, sendGetCodeHandle: u } = Qt(N);
    ke(() => {
      De();
    });
    function L() {
      o.value.loginMethod === "phone" ? u() : N();
    }
    return (f, v) => {
      const V = G("i18n-t");
      return T(), F(r(Ce), {
        class: "mc-login__card",
        onSubmit: D(Ge, ["prevent"])
      }, {
        default: h(() => [
          b("div", _a, O(r(c)("login.title")), 1),
          w(r(te), {
            modelValue: o.value.account,
            "onUpdate:modelValue": v[0] || (v[0] = ($) => o.value.account = $),
            outlined: "",
            readonly: "",
            class: "item-input account-input"
          }, {
            append: h(() => [
              w(r(X), {
                class: "text-btn",
                flat: "",
                "no-caps": "",
                color: "primary",
                onClick: j
              }, {
                default: h(() => [
                  K(O(r(c)("login.actions.change")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          w(r(te), {
            ref_key: "verifyCodeRef",
            ref: p,
            modelValue: o.value.code,
            "onUpdate:modelValue": v[1] || (v[1] = ($) => o.value.code = $),
            rules: [R],
            maxlength: "6",
            "no-error-icon": "",
            type: "text",
            label: r(c)("login.code.label"),
            class: "item-input",
            outlined: "",
            "error-message": n.value,
            error: !!n.value,
            autocomplete: "one-time-code",
            mask: "########"
          }, {
            append: h(() => [
              r(m) > 0 ? (T(), H("span", ba, O(r(m)), 1)) : (T(), F(r(X), {
                key: 1,
                class: "text-btn",
                loading: r(C),
                flat: "",
                "no-caps": "",
                color: "primary",
                onClick: L
              }, {
                default: h(() => [
                  K(O(r(c)("login.code.send")), 1)
                ]),
                _: 1
              }, 8, ["loading"]))
            ]),
            _: 1
          }, 8, ["modelValue", "rules", "label", "error-message", "error"]),
          w(r(te), {
            modelValue: o.value.password,
            "onUpdate:modelValue": v[3] || (v[3] = ($) => o.value.password = $),
            rules: [E],
            outlined: "",
            type: k.value ? "password" : "text",
            label: r(c)("login.password.label"),
            class: "item-input",
            "no-error-icon": "",
            autocomplete: "current-password"
          }, {
            append: h(() => [
              b("div", {
                onClick: v[2] || (v[2] = ($) => k.value = !k.value)
              }, [
                k.value ? (T(), H("svg", ka, [...v[12] || (v[12] = [
                  b("path", {
                    d: "M20.6523 21.2624C20.3367 21.2624 20.0289 21.1015 19.8548 20.8115L17.9992 17.7155C17.7354 17.2752 17.8786 16.7052 18.3186 16.4409C18.7586 16.1771 19.3289 16.3205 19.5926 16.7602L21.4482 19.8562C21.712 20.2965 21.5689 20.8665 21.1289 21.1309C20.9849 21.2171 20.8201 21.2626 20.6523 21.2624ZM25.6001 18.1665C25.3623 18.1665 25.1245 18.0759 24.9432 17.8943L22.4689 15.4174C22.1064 15.054 22.1067 14.4662 22.4695 14.1034C22.8323 13.7418 23.4201 13.7412 23.7829 14.104L26.2573 16.5809C26.6198 16.9443 26.6195 17.5321 26.2567 17.8949C26.1705 17.9811 26.0681 18.0495 25.9555 18.0961C25.8428 18.1427 25.722 18.1666 25.6001 18.1665ZM11.3526 21.2624C11.1901 21.2624 11.0254 21.2202 10.8761 21.1299C10.4357 20.8662 10.2932 20.2962 10.5567 19.8559L12.4123 16.7599C12.6761 16.3202 13.2464 16.1765 13.6864 16.4412C14.1267 16.7049 14.2692 17.2749 14.0057 17.7152L12.1501 20.8112C11.9761 21.1015 11.6682 21.2624 11.3526 21.2624ZM6.40512 18.1665C6.16762 18.1665 5.93012 18.0759 5.74887 17.8949C5.38605 17.5321 5.38574 16.9443 5.74824 16.5809L8.22262 14.104C8.58543 13.7412 9.17324 13.7418 9.53606 14.1034C9.89887 14.4662 9.89918 15.054 9.53668 15.4174L7.0623 17.8943C6.88074 18.0759 6.64293 18.1665 6.40512 18.1665Z",
                    fill: "black"
                  }, null, -1),
                  b("path", {
                    d: "M16.301 17.5478C13.7129 17.5478 9.90541 16.6612 6.46072 12.4375C6.42103 12.3884 6.39041 12.3503 6.36791 12.3244C6.02728 11.9862 5.99822 11.4378 6.31353 11.0653C6.64478 10.6734 7.23072 10.625 7.62228 10.9559C7.66166 10.989 7.7601 11.0912 7.90041 11.2631C10.8838 14.9222 14.1154 15.69 16.301 15.69C20.0726 15.69 24.3657 11.7959 24.7892 11.1772C25.0729 10.764 25.6438 10.6306 26.0673 10.9009C26.4898 11.1706 26.6342 11.7075 26.3788 12.1387C25.9395 12.88 21.1051 17.5478 16.301 17.5478Z",
                    fill: "black"
                  }, null, -1)
                ])])) : (T(), H("svg", Ca, [...v[11] || (v[11] = [
                  b("path", {
                    d: "M15.9975 26C11.1085 26 6.74683 22.9147 2.92217 16.8873C2.75359 16.6221 2.66406 16.3143 2.66406 16C2.66406 15.6857 2.75359 15.3779 2.92217 15.1127C6.74683 9.08533 11.1085 6 15.9975 6C20.8865 6 25.2482 9.08533 29.0728 15.1127C29.2414 15.3779 29.3309 15.6857 29.3309 16C29.3309 16.3143 29.2414 16.6221 29.0728 16.8873C25.2482 22.9147 20.8865 26 15.9975 26ZM15.9975 8C11.9502 8 8.20183 10.6203 4.74383 16C8.20183 21.3797 11.9502 24 15.9975 24C20.0448 24 23.7932 21.3797 27.2512 16C23.7932 10.6203 20.0448 8 15.9975 8ZM15.9975 20.6667C13.3972 20.6667 11.2892 18.5773 11.2892 16C11.2892 13.4227 13.3972 11.3333 15.9975 11.3333C18.5978 11.3333 20.7058 13.4227 20.7058 16C20.7058 18.5773 18.5978 20.6667 15.9975 20.6667ZM15.9975 18.6667C17.4835 18.6667 18.6882 17.4727 18.6882 16C18.6882 14.5273 17.4835 13.3333 15.9975 13.3333C14.5115 13.3333 13.3068 14.5273 13.3068 16C13.3068 17.4727 14.5115 18.6667 15.9975 18.6667Z",
                    fill: "black"
                  }, null, -1)
                ])]))
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "rules", "type", "label"]),
          w(r(te), {
            modelValue: o.value.babyBirthday,
            "onUpdate:modelValue": v[5] || (v[5] = ($) => o.value.babyBirthday = $),
            class: "item-input",
            outlined: "",
            rules: [Z],
            label: r(c)("login.birthday.label_html"),
            placeholder: r(c)("login.birthday.placeholder_html"),
            "no-error-icon": "",
            mask: "####-##-##"
          }, {
            append: h(() => [
              w(r(kt), {
                name: "event",
                class: "cursor-pointer"
              })
            ]),
            default: h(() => [
              w(r(_t), {
                class: "nt",
                "transition-show": "scale",
                "transition-hide": "scale"
              }, {
                default: h(() => [
                  w(r(bt), {
                    modelValue: o.value.babyBirthday,
                    "onUpdate:modelValue": v[4] || (v[4] = ($) => o.value.babyBirthday = $),
                    mask: "YYYY-MM-DD"
                  }, {
                    default: h(() => [
                      b("div", Ea, [
                        Ne(w(r(X), {
                          label: r(c)("login.common.close"),
                          color: "primary",
                          flat: ""
                        }, null, 8, ["label"]), [
                          [r(i)]
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "rules", "label", "placeholder"]),
          w(r(X), {
            type: "submit",
            loading: B.value,
            class: "mc-login__btn"
          }, {
            default: h(() => [
              K(O(r(c)("login.actions.createAccount")), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          b("div", Sa, [
            b("div", {
              ref_key: "policyRef",
              ref: I
            }, [
              w(r(ye), {
                modelValue: o.value.agreePolicy,
                "onUpdate:modelValue": v[8] || (v[8] = ($) => o.value.agreePolicy = $),
                size: "sm",
                class: qe(["item-subscribe", U.value && !o.value.agreePolicy && "error-msg"]),
                "true-value": 1,
                "false-value": 0
              }, {
                default: h(() => [
                  w(V, {
                    keypath: "login.terms.policyInfo",
                    class: "policy-info",
                    tag: "span"
                  }, {
                    privacy: h(() => [
                      b("a", {
                        href: `${r(qt)}?countryCode=${r(l).country}&client=1&isShowCountry=hide`,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "aria-label": "Privacy Policy (opens in a new tab)",
                        "aria-describedby": "a11y-new-window-external-message",
                        onClick: v[6] || (v[6] = D(() => {
                        }, ["stop"]))
                      }, O(f.$t("login.terms.privacy")), 9, xa)
                    ]),
                    terms: h(() => [
                      b("a", {
                        href: "/pages/terms-conditions",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "aria-label": "Terms & Conditions (opens in a new tab)",
                        "aria-describedby": "a11y-new-window-message",
                        onClick: v[7] || (v[7] = D(() => {
                        }, ["stop"]))
                      }, O(f.$t("login.terms.terms_html")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "class"])
            ], 512)
          ]),
          o.value.loginMethod === "phone" ? (T(), F(r(ye), {
            key: 0,
            modelValue: o.value.subscribeNews,
            "onUpdate:modelValue": v[9] || (v[9] = ($) => o.value.subscribeNews = $),
            size: "sm",
            class: "item-subscribe",
            label: r(c)("login.newsletter.labelPhone"),
            "true-value": 1,
            "false-value": 0
          }, null, 8, ["modelValue", "label"])) : (T(), F(r(ye), {
            key: 1,
            modelValue: o.value.subscribeNews,
            "onUpdate:modelValue": v[10] || (v[10] = ($) => o.value.subscribeNews = $),
            size: "sm",
            class: "item-subscribe",
            label: r(c)("login.newsletter.labelEmail"),
            "true-value": 1,
            "false-value": 0
          }, null, 8, ["modelValue", "label"])),
          w(wa, {
            ref_key: "verifyEmailWhenPhoneRef",
            ref: z,
            data: o.value,
            "register-info": r(d),
            onSuccess: J
          }, null, 8, ["data", "register-info"])
        ]),
        _: 1
      });
    };
  }
}, Ta = /* @__PURE__ */ oe(La, [["__scopeId", "data-v-a3d44dcb"]]), Va = { class: "mc-login__container" }, Pa = { class: "divide-line" }, Ra = { class: "third-content" }, $a = {
  __name: "login",
  props: {
    country: { type: String, default: "US" },
    countryName: { type: String, default: "United States" },
    activityType: { type: String },
    mustAgreeEmail: { type: Boolean, default: !1 },
    loginSubscribeNews: { type: Boolean, default: !1 },
    redirect: { type: String }
  },
  setup(e, { expose: t }) {
    const a = e, s = x({
      ...a
    });
    Lt("config", s);
    const { t: i } = fe(), l = x(!1), c = [
      {
        label: i("login.country.us"),
        value: "US",
        name: "United States",
        displayValue: "1"
      },
      {
        label: i("login.country.ca"),
        value: "CA",
        name: "Canada",
        displayValue: "1"
      }
    ], o = x({
      account: "",
      password: "",
      code: "",
      babyBirthday: "",
      subscribeNews: 0,
      agreePolicy: 0,
      areaCode: c[0],
      loginType: "",
      // login, register
      loginMethod: "",
      // email, phone
      passwordType: "password",
      // password, code
      countryCode: s.value.country,
      countryName: s.value.countryName
    });
    function d(m) {
      const y = /^[^\s@]+@[^\s@][^\s.@]*\.[^\s@]+$/;
      o.value.account && !y.test(o.value.account) && (o.value.account = ""), o.value = {
        ...o.value,
        ...m
      };
    }
    function p(m) {
      ct(m.token), location.href = m.shopifyLoginToken, C(!0);
    }
    const { handleCheck: n } = jt(o, s);
    async function _(m = {}, y = {}) {
      if (o.value = { ...o.value, ...m }, s.value = { ...a, ...y }, o.value.account && y.checkImmediately) {
        const M = await n();
        d(M);
      }
      l.value = !0;
    }
    function C(m = !1) {
      if (s.value.persistent && !m) {
        document.dispatchEvent(new hn());
        return;
      }
      l.value = !1;
    }
    return ke(async () => {
      document.addEventListener("LUTE:AUTH:EXPIRED", () => {
        Rt();
      });
      const m = Be();
      if (m) {
        const y = await At();
        y && y.email && (window.__MOMCOZY_USER_INFO__ = {
          email: y.email,
          token: m
        }, document.body.classList.add("momcozy-logined"), document.dispatchEvent(
          new yn({
            type: "keep",
            email: y.email,
            token: m
          })
        ));
      }
    }), t({
      close: C,
      open: _
    }), (m, y) => (T(), F(r(Ve), Tt({
      modelValue: l.value,
      "onUpdate:modelValue": y[4] || (y[4] = (M) => l.value = M),
      class: "mc-login nt"
    }, s.value, {
      onShake: y[5] || (y[5] = (M) => C(!1))
    }), {
      default: h(() => [
        b("div", Va, [
          w(Vt, {
            name: "form",
            tag: "div",
            class: "mc-login__forms"
          }, {
            default: h(() => [
              o.value.loginType ? o.value.loginType === "login" ? (T(), F(pa, {
                key: "login",
                form: o.value,
                "onUpdate:form": y[1] || (y[1] = (M) => o.value = M),
                class: "login-form",
                onStep: d,
                onSuccess: p
              }, null, 8, ["form"])) : o.value.loginType === "register" ? (T(), F(Ta, {
                key: "register",
                form: o.value,
                "onUpdate:form": y[2] || (y[2] = (M) => o.value = M),
                class: "register-form",
                onStep: d,
                onSuccess: p
              }, null, 8, ["form"])) : ne("", !0) : (T(), F(Wn, {
                key: "check",
                form: o.value,
                "onUpdate:form": y[0] || (y[0] = (M) => o.value = M),
                class: "check-form",
                "intel-code-list": c,
                onStep: d
              }, null, 8, ["form"]))
            ]),
            _: 1
          }),
          b("p", Pa, [
            b("span", null, O(r(i)("login.or")), 1)
          ]),
          b("div", Ra, [
            w(aa),
            w(ta),
            w(zn)
          ]),
          w(r(X), {
            class: "mc-close-icon",
            icon: "close",
            flat: "",
            round: "",
            dense: "",
            onClick: y[3] || (y[3] = (M) => C(!1))
          })
        ])
      ]),
      _: 1
    }, 16, ["modelValue"]));
  }
}, Ma = /* @__PURE__ */ oe($a, [["__scopeId", "data-v-5733aa5d"]]), Ia = "data:image/svg+xml,%3csvg%20width='26'%20height='26'%20viewBox='0%200%2026%2026'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='13'%20cy='13'%20r='11.2'%20stroke='%236FC177'%20stroke-width='1.6'/%3e%3cg%20clip-path='url(%23clip0_1602_999)'%3e%3cpath%20d='M8.19077%2012.5013L10.9966%2014.7369L17.9831%208.30061C17.9831%208.30061%2018.4518%207.8727%2018.8613%208.20704C18.9829%208.30701%2019.1236%208.59175%2018.8069%209.03807L11.5125%2017.5826C11.5125%2017.5826%2010.9534%2018.3481%2010.2895%2017.5746L7.14141%2013.3243C7.14141%2013.3243%206.76788%2012.7485%207.23498%2012.4037C7.39334%2012.2886%207.75167%2012.1078%208.19077%2012.5013Z'%20fill='%236FC177'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1602_999'%3e%3crect%20width='12'%20height='12'%20fill='white'%20transform='translate(7%207)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Oa = ["innerHTML"], Ua = { class: "row items-center justify-end" }, Na = ["href"], qa = {
  __name: "quickRegisterForm",
  props: {
    form: {
      type: Object,
      required: !0
    },
    formModifiers: {}
  },
  emits: /* @__PURE__ */ _e(["step", "success", "close"], ["update:form"]),
  setup(e, { emit: t }) {
    const a = t, s = pe(), i = Ct, l = me("config", {}), { t: c } = fe(), o = Oe(e, "form");
    o.value && (o.value.protocol = 0);
    const {
      suggestionMenu: d,
      activeSuggestionIndex: p,
      computedEmailOptions: n,
      selectEmailOption: _,
      moveSuggestion: C,
      applyActiveSuggestion: m,
      highlightSuggestion: y
    } = mt(o), M = ue(() => c("login.form.labelEmail"));
    function A() {
      if (!o.value.account || !ft.test(o.value.account))
        return c("login.form.validateEmailRequired");
    }
    const P = Dt(l);
    function N() {
      a("close");
    }
    const j = /^(?:\d{3}[1-9]|\d{2}[1-9]\d|\d[1-9]\d{2}|[1-9]\d{3})-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|02-(?:0[1-9]|1\d|2[0-8]))|(?:\d{2}(?:0[48]|[2468][048]|[13579][26])|(?:0[48]|[2468][048]|[3579][26])00)-02-29$/;
    function R() {
      if (!o.value.babyBirthday)
        return c("login.birthday.validateRequired_html");
      if (!j.test(o.value.babyBirthday))
        return c("login.birthday.validateInvalid_html");
    }
    const k = x(!1);
    async function E() {
      try {
        const I = {
          subscribeNews: o.value.subscribeNews,
          // 订阅
          email: o.value.account,
          // 邮箱
          currentStageValue: o.value.babyBirthday,
          // 预产期
          agreePrivacyCountryCode: l.value.country,
          ...P.value,
          source: P.value.registerSource || ""
        };
        delete I.registerSource;
        const g = await Rn(I);
        g.isRegister === 1 ? a("success", {
          type: "register",
          status: "success",
          message: g.message
        }) : g.code === "10004007" ? a("success", {
          type: "register",
          status: "notActivated",
          message: g.message
        }) : g.code === "10004050" ? a("success", {
          type: "register",
          status: "activated",
          message: g.message
        }) : s.notify({
          message: g.message,
          color: "negative",
          position: "top",
          timeout: 3e3
        });
      } catch {
        console.log("服务错误！");
      }
    }
    const S = ge("termsRef"), Z = x(!1);
    function z() {
      Z.value = !0, B(S.value);
    }
    function B(I) {
      I.animate(
        {
          transform: [
            "translateX(0)",
            "translateX(-32px)",
            "translateX(32px)",
            "translateX(-16px)",
            "translateX(16px)",
            "translateX(-8px)",
            "translateX(8px)",
            "translateX(-4px)",
            "translateX(4px)",
            "translateX(-2px)",
            "translateX(2px)",
            "translateX(0)"
          ]
        },
        {
          duration: 1e3,
          easing: "cubic-bezier(.36, .07, .19, .97)",
          fill: "forwards"
        }
      );
    }
    function W() {
      return o.value.protocol ? !0 : (s.notify({
        message: c("login.terms.policyTip_html"),
        position: "center",
        classes: "mc-notify--policy",
        multiLine: !0,
        html: !0,
        timeout: 2e3
      }), !1);
    }
    async function Y() {
      try {
        if (!W()) {
          z();
          return;
        }
        k.value = !0, await E();
      } finally {
        k.value = !1;
      }
    }
    return (I, g) => {
      const U = G("i18n-t");
      return T(), F(r(Ce), {
        class: "mc-login__card",
        onSubmit: D(Y, ["prevent"])
      }, {
        default: h(() => [
          g[10] || (g[10] = b("div", { class: "mc-register-login__title" }, "Email Registration", -1)),
          w(r(te), {
            modelValue: o.value.account,
            "onUpdate:modelValue": g[1] || (g[1] = (q) => o.value.account = q),
            autofocus: "",
            outlined: "",
            "no-error-icon": "",
            label: M.value,
            class: "item-input account-input",
            maxlength: "50",
            autocomplete: "username",
            rules: [A],
            onKeydown: [
              g[2] || (g[2] = ie(D((q) => r(C)(1), ["prevent"]), ["down"])),
              g[3] || (g[3] = ie(D((q) => r(C)(-1), ["prevent"]), ["up"])),
              ie(D(r(m), ["prevent"]), ["enter"])
            ]
          }, {
            default: h(() => [
              w(r(tt), {
                modelValue: r(d),
                "onUpdate:modelValue": g[0] || (g[0] = (q) => Me(d) ? d.value = q : null),
                anchor: "bottom left",
                self: "top left",
                fit: "",
                "no-parent-event": "",
                "no-focus": "",
                offset: [0, 4],
                class: "email-menu",
                cover: !1
              }, {
                default: h(() => [
                  w(r(ot), { class: "email-menu__list" }, {
                    default: h(() => [
                      (T(!0), H(Ue, null, it(r(n), (q, J) => (T(), F(r(nt), {
                        key: q,
                        clickable: "",
                        dense: "",
                        active: J === r(p),
                        onMouseenter: (ae) => p.value = J,
                        onClick: (ae) => r(_)(q)
                      }, {
                        default: h(() => [
                          w(r(at), null, {
                            default: h(() => [
                              b("span", {
                                innerHTML: r(y)(q)
                              }, null, 8, Oa)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["active", "onMouseenter", "onClick"]))), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue", "label", "rules", "onKeydown"]),
          w(r(te), {
            modelValue: o.value.babyBirthday,
            "onUpdate:modelValue": g[5] || (g[5] = (q) => o.value.babyBirthday = q),
            class: "item-input",
            outlined: "",
            rules: [R],
            label: r(c)("login.birthday.label_html"),
            placeholder: r(c)("login.birthday.placeholder_html"),
            "no-error-icon": "",
            mask: "####-##-##"
          }, {
            append: h(() => [
              w(r(kt), {
                name: "event",
                class: "cursor-pointer"
              })
            ]),
            default: h(() => [
              w(r(_t), {
                class: "nt",
                "transition-show": "scale",
                "transition-hide": "scale"
              }, {
                default: h(() => [
                  w(r(bt), {
                    modelValue: o.value.babyBirthday,
                    "onUpdate:modelValue": g[4] || (g[4] = (q) => o.value.babyBirthday = q),
                    mask: "YYYY-MM-DD"
                  }, {
                    default: h(() => [
                      b("div", Ua, [
                        Ne(w(r(X), {
                          label: r(c)("login.common.close"),
                          color: "primary",
                          flat: ""
                        }, null, 8, ["label"]), [
                          [r(i)]
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "rules", "label", "placeholder"]),
          w(r(X), {
            type: "submit",
            loading: k.value,
            class: "mc-login__btn"
          }, {
            default: h(() => [
              K(O(r(c)("login.actions.createAccount")), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          b("div", {
            ref_key: "termsRef",
            ref: S,
            class: "mc-register__terms"
          }, [
            w(r(ye), {
              modelValue: o.value.protocol,
              "onUpdate:modelValue": g[8] || (g[8] = (q) => o.value.protocol = q),
              size: "sm",
              class: qe(["item-subscribe", Z.value && !o.value.protocol && "error-msg"]),
              "true-value": 1,
              "false-value": 0
            }, {
              default: h(() => [
                w(U, {
                  keypath: "login.terms.policyInfo",
                  class: "policy-info",
                  tag: "span"
                }, {
                  privacy: h(() => [
                    b("a", {
                      href: `${r(qt)}?countryCode=${r(l).country}&client=1&isShowCountry=hide`,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      "aria-label": "Privacy Policy (opens in a new tab)",
                      "aria-describedby": "a11y-new-window-external-message",
                      onClick: g[6] || (g[6] = D(() => {
                      }, ["stop"]))
                    }, O(I.$t("login.terms.privacy")), 9, Na)
                  ]),
                  terms: h(() => [
                    b("a", {
                      href: "/pages/terms-conditions",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      "aria-label": "Terms & Conditions (opens in a new tab)",
                      "aria-describedby": "a11y-new-window-message",
                      onClick: g[7] || (g[7] = D(() => {
                      }, ["stop"]))
                    }, O(I.$t("login.terms.terms_html")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "class"])
          ], 512),
          w(r(ye), {
            modelValue: o.value.subscribeNews,
            "onUpdate:modelValue": g[9] || (g[9] = (q) => o.value.subscribeNews = q),
            size: "sm",
            class: "item-subscribe",
            label: r(c)("login.newsletter.labelEmail"),
            "true-value": 1,
            "false-value": 0
          }, null, 8, ["modelValue", "label"]),
          b("div", {
            class: "already-registered",
            onClick: N
          }, " I have registered ")
        ]),
        _: 1
      });
    };
  }
}, Aa = /* @__PURE__ */ oe(qa, [["__scopeId", "data-v-9649d0c6"]]), Fa = { class: "mc-login__container" }, Ba = { class: "success-icon-wrapper" }, ja = { class: "success-subtitle" }, Ha = { class: "success-message" }, Za = {
  __name: "quickRegisterMember",
  props: {
    country: { type: String, default: "US" },
    activityType: { type: String },
    mustAgreeEmail: { type: Boolean, default: !1 },
    loginSubscribeNews: { type: Boolean, default: !1 },
    redirect: { type: String }
  },
  setup(e, { expose: t }) {
    const a = e, s = x({
      ...a
    });
    Lt("config", s);
    const i = x(!1), l = x(!1), c = we({}), o = x({
      account: "",
      babyBirthday: "",
      subscribeNews: 0
      // 协议
    });
    function d(C) {
      Object.assign(c, C), i.value = !1, l.value = !0, document.dispatchEvent(new ho());
    }
    function p() {
      l.value = !1, _(!0);
    }
    async function n(C = {}, m = {}) {
      o.value = { ...o.value, ...C }, s.value = { ...a, ...m }, i.value = !0;
    }
    function _(C = !1) {
      if (s.value.persistent && !C) {
        document.dispatchEvent(new yo());
        return;
      }
      i.value = !1;
    }
    return ke(async () => {
      document.addEventListener("LUTE:AUTH:EXPIRED", () => {
        Rt();
      });
      const C = Be();
      if (C) {
        const m = await At();
        m && m.email && (window.__MOMCOZY_USER_INFO__ = {
          email: m.email,
          token: C
        }, document.body.classList.add("momcozy-logined"), document.dispatchEvent(
          new go({
            type: "keep",
            email: m.email,
            token: C
          })
        ));
      }
    }), t({
      close: _,
      open: n
    }), (C, m) => (T(), H(Ue, null, [
      w(r(Ve), Tt({
        modelValue: i.value,
        "onUpdate:modelValue": m[3] || (m[3] = (y) => i.value = y),
        class: "mc-login nt"
      }, s.value, {
        onShake: m[4] || (m[4] = (y) => _(!1))
      }), {
        default: h(() => [
          b("div", Fa, [
            w(Vt, {
              name: "form",
              tag: "div",
              class: "mc-login__forms"
            }, {
              default: h(() => [
                w(Aa, {
                  key: "register",
                  form: o.value,
                  "onUpdate:form": m[0] || (m[0] = (y) => o.value = y),
                  onSuccess: d,
                  onClose: m[1] || (m[1] = (y) => _(!1))
                }, null, 8, ["form"])
              ]),
              _: 1
            }),
            w(r(X), {
              class: "mc-close-icon",
              icon: "close",
              flat: "",
              round: "",
              dense: "",
              onClick: m[2] || (m[2] = (y) => _(!1))
            })
          ])
        ]),
        _: 1
      }, 16, ["modelValue"]),
      w(r(Ve), {
        modelValue: l.value,
        "onUpdate:modelValue": m[5] || (m[5] = (y) => l.value = y),
        persistent: "",
        class: "success-dialog"
      }, {
        default: h(() => [
          w(r(Kt), { class: "success-card" }, {
            default: h(() => [
              w(r(X), {
                icon: "close",
                flat: "",
                round: "",
                dense: "",
                class: "success-close-btn",
                onClick: p
              }),
              w(r(Wt), { class: "success-content text-center" }, {
                default: h(() => [
                  m[7] || (m[7] = b("div", { class: "success-title" }, " Earn points on this purchase ", -1)),
                  b("div", Ba, [
                    m[6] || (m[6] = b("img", {
                      src: Ia,
                      alt: "",
                      class: "success-icon"
                    }, null, -1)),
                    b("div", ja, O(c.status === "success" ? "Sign-up successful!" : c.status === "notActivated" ? "Your account has not been created/activated!" : "You're already a Cozy Club member!"), 1)
                  ]),
                  b("div", Ha, O(c.status === "success" ? "An initial password has been sent to your email. Check your inbox to view your points balance." : c.status === "notActivated" ? "Please register or check your activation email." : "your points will be automatically added after each purchase."), 1),
                  c.status === "success" ? (T(), F(r(X), {
                    key: 0,
                    unelevated: "",
                    color: "dark",
                    label: "OK",
                    class: "confirm-btn",
                    onClick: p
                  })) : ne("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 64));
  }
}, Ga = /* @__PURE__ */ oe(Za, [["__scopeId", "data-v-7cc2be26"]]), Yt = "data:image/svg+xml,%3csvg%20width='48'%20height='48'%20viewBox='0%200%2048%2048'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='common_icons_miniprogram'%3e%3cpath%20id='Oval%2078'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M24%2048C10.7452%2048%200%2037.2548%200%2024C0%2010.7452%2010.7452%200%2024%200C37.2548%200%2048%2010.7452%2048%2024C48%2037.2548%2037.2548%2048%2024%2048Z'%20fill='%2307C160'/%3e%3cpath%20id='Combined%20Shape'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.1763%2029.1337L34.6146%2015.6953L37.1647%2018.2454L22.8793%2032.5249C21.9417%2033.462%2020.4219%2033.4616%2019.4849%2032.5239L12%2025.0336L14.5381%2022.4955L21.1763%2029.1337Z'%20fill='white'/%3e%3c/g%3e%3c/svg%3e", Da = { class: "diaglog-content" }, Qa = {
  key: 1,
  class: "text-btn"
}, za = { class: "btn-group" }, Ya = {
  __name: "thirdLoginCompleteInfo",
  setup(e, { expose: t }) {
    const a = pe(), s = x(!1), i = x(!1), l = x(null), c = x(null), o = x({
      email: "",
      code: ""
    }), d = x({}), p = x(!1), n = x({}), _ = we({
      email: [
        (E) => E && E.length > 0 || "Email is required.",
        (E, S) => S.email(E) || "Please enter your correct email address"
      ],
      code: [(E) => !!E || "Please enter correct code"]
    });
    let C = null;
    const m = x(60), y = x(!1), M = x(!1);
    function A(E, S) {
      let Z;
      return function(...z) {
        clearTimeout(Z), Z = setTimeout(() => E.apply(this, z), S);
      };
    }
    const P = A(async () => {
      if (m.value = 60, !await l.value.validate())
        return;
      const S = await Tn({
        email: o.value.email,
        sid: n.value.sid,
        type: 6
      });
      Reflect.has(S, "status") && (y.value = !0, M.value = !1, C = setInterval(() => {
        m.value--, m.value === 0 && (clearInterval(C), y.value = !1);
      }, 1e3), S?.status === 11 && (M.value = !0, a.notify({
        message: "The session has expired and needs to be restarted",
        color: "negative",
        position: "top",
        timeout: 3e3
      })));
    }, 300);
    async function N() {
      await l.value.validate() && P();
    }
    async function j() {
      if (p.value)
        document.dispatchEvent(
          new $e({
            type: "assembly-login",
            ...d.value,
            sid: n.value.sid,
            platform: n.value.platform
          })
        ), s.value = !1;
      else {
        if (!await c.value.validate())
          return;
        i.value = !0;
        try {
          let S = await Vn({
            code: o.value.code,
            sid: n.value.sid
          });
          S = S || {}, d.value = S, S?.status === 11 ? a.notify({
            message: "The session has expired and needs to be restarted",
            color: "negative",
            position: "center",
            timeout: 3e3
          }) : S?.status === 12 ? a.notify({
            message: "Please enter the correct verification code",
            color: "negative",
            position: "center",
            timeout: 3e3
          }) : Reflect.has(S, "status") && (S.token && ct(S.token), p.value = !0);
        } catch (S) {
          console.error("Verify mail code failed:", S);
        } finally {
          i.value = !1;
        }
      }
    }
    function R() {
      document.dispatchEvent(
        new $e({
          type: "assembly-login",
          ...d.value,
          sid: n.value.sid,
          platform: n.value.platform
        })
      ), s.value = !1;
    }
    function k(E = { sid: "", platform: "" }) {
      s.value = !0, c.value?.resetValidation(), o.value.email = "", o.value.code = "", d.value = {}, p.value = !1, y.value = !1, M.value = !1, m.value = 60, n.value = E;
    }
    return t({
      open: k
    }), (E, S) => {
      const Z = G("q-space"), z = G("q-btn"), B = G("q-card-section"), W = G("q-input"), Y = G("q-form"), I = G("q-card-actions"), g = G("q-card"), U = G("q-dialog"), q = Pt("close-popup");
      return T(), F(U, {
        modelValue: s.value,
        "onUpdate:modelValue": S[2] || (S[2] = (J) => s.value = J),
        persistent: "",
        onBeforeHide: R
      }, {
        default: h(() => [
          w(g, { style: { "max-width": "600px", "overflow-x": "hidden" } }, {
            default: h(() => [
              w(B, { class: "row items-center q-pb-none q-pt-lg" }, {
                default: h(() => [
                  w(Z),
                  Ne(w(z, {
                    icon: "close",
                    flat: "",
                    round: "",
                    dense: ""
                  }, null, 512), [
                    [q]
                  ])
                ]),
                _: 1
              }),
              b("div", Da, [
                w(B, { class: "dialog-title" }, {
                  default: h(() => [
                    K(O(p.value ? "Registration successful" : "Create account"), 1)
                  ]),
                  _: 1
                }),
                p.value ? (T(), F(B, {
                  key: 0,
                  class: "row justify-center items-center q-py-none q-px-none q-pb-lg"
                }, {
                  default: h(() => [...S[3] || (S[3] = [
                    b("img", {
                      src: Yt,
                      alt: "",
                      srcset: "",
                      style: { width: "48px", height: "48px" }
                    }, null, -1)
                  ])]),
                  _: 1
                })) : ne("", !0),
                w(B, { class: "dialog-des" }, {
                  default: h(() => [
                    K(O(p.value ? `You have successfully registered, and your account has been linked to ${n.value.platform}. In the future, you can log in using ${n.value.platform} or your email.` : "Please provide the missing information so we can create a Momcozy account."), 1)
                  ]),
                  _: 1
                }),
                p.value ? ne("", !0) : (T(), F(I, {
                  key: 1,
                  class: "text-center q-pa-none"
                }, {
                  default: h(() => [
                    w(Y, {
                      ref_key: "formRef",
                      ref: c,
                      class: "full-width",
                      onSubmit: D(j, ["prevent"])
                    }, {
                      default: h(() => [
                        w(W, {
                          ref_key: "emailInput",
                          ref: l,
                          modelValue: o.value.email,
                          "onUpdate:modelValue": S[0] || (S[0] = (J) => o.value.email = J),
                          rules: _.email,
                          type: "text",
                          label: "* E-mail",
                          class: "q-pb-lg",
                          outlined: ""
                        }, {
                          append: h(() => [
                            y.value ? (T(), H("span", Qa, O(m.value), 1)) : (T(), H("span", {
                              key: 0,
                              class: "text-btn cursor-pointer",
                              onClick: N
                            }, "Get code"))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        w(W, {
                          modelValue: o.value.code,
                          "onUpdate:modelValue": S[1] || (S[1] = (J) => o.value.code = J),
                          rules: _.code,
                          type: "text",
                          class: "q-pb-lg",
                          label: "* Enter code",
                          outlined: ""
                        }, xt({ _: 2 }, [
                          y.value && !M.value ? {
                            name: "hint",
                            fn: h(() => [
                              S[4] || (S[4] = K(" A verification email has been sent to your inbox. Please check your email to verify your account. ", -1))
                            ]),
                            key: "0"
                          } : void 0
                        ]), 1032, ["modelValue", "rules"]),
                        b("div", za, [
                          w(z, {
                            loading: i.value,
                            size: "lg",
                            class: "full-width",
                            label: "Confirm",
                            type: "submit",
                            color: "dark"
                          }, null, 8, ["loading"])
                        ])
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                })),
                p.value ? (T(), H("div", {
                  key: 2,
                  class: qe(["btn-group", { success: p.value }])
                }, [
                  w(z, {
                    loading: i.value,
                    size: "lg",
                    class: "full-width",
                    label: "Confirm",
                    type: "submit",
                    color: "dark",
                    onClick: j
                  }, null, 8, ["loading"])
                ], 2)) : ne("", !0)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}, Xa = /* @__PURE__ */ oe(Ya, [["__scopeId", "data-v-68fdc9dc"]]), Ka = { class: "diaglog-content" }, Wa = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ja = {
  key: 1,
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, es = { style: { "margin-top": "0", display: "flex", "justify-content": "flex-end", "align-items": "center" } }, ts = ["href"], os = { class: "btn-group" }, ns = {
  __name: "thirdVerifyPassword",
  setup(e, { expose: t }) {
    const a = pe(), { t: s } = fe(), i = x(!1), l = x(!1), c = x(null), o = x({
      password: ""
    }), d = x({}), p = x(!1), n = x("password"), _ = x({}), C = we({
      password: [(A) => !!A || "Please enter your password"]
    });
    function m() {
      document.dispatchEvent(
        new $e({
          type: "assembly-login",
          ...d.value,
          sid: _.value.sid,
          platform: _.value.platform
        })
      ), i.value = !1;
    }
    async function y() {
      if (p.value)
        document.dispatchEvent(
          new $e({
            type: "assembly-login",
            ...d.value,
            sid: _.value.sid,
            platform: _.value.platform
          })
        ), i.value = !1;
      else {
        if (!await c.value.validate())
          return;
        const P = je(o.value.password);
        try {
          const N = await Pn({
            password: P,
            sid: _.value.sid
          }).finally(() => {
            l.value = !1;
          });
          d.value = N ? { ...N } : {}, d.value?.status === 11 ? a.notify({
            message: "The session has expired and needs to be restarted",
            color: "negative",
            position: "center",
            timeout: 3e3
          }) : Object.prototype.hasOwnProperty.call(d.value, "status") && (N.token && ct(N.token), p.value = !0);
        } catch {
          l.value = !1;
        }
      }
    }
    function M(A = { sid: "", platform: "", email: "" }) {
      i.value = !0, c.value?.resetValidation(), o.value.password = "", d.value = {}, p.value = !1, _.value = A;
    }
    return t({
      open: M
    }), (A, P) => {
      const N = G("q-space"), j = G("q-btn"), R = G("q-card-section"), k = G("svg-icon"), E = G("q-input"), S = G("q-form"), Z = G("q-card-actions"), z = G("q-card"), B = G("q-dialog"), W = Pt("close-popup");
      return T(), F(B, {
        modelValue: i.value,
        "onUpdate:modelValue": P[3] || (P[3] = (Y) => i.value = Y),
        persistent: "",
        onBeforeHide: m
      }, {
        default: h(() => [
          w(z, { style: { "max-width": "600px", "overflow-x": "hidden" } }, {
            default: h(() => [
              w(R, { class: "row items-center q-pb-none q-pt-lg" }, {
                default: h(() => [
                  w(N),
                  Ne(w(j, {
                    icon: "close",
                    flat: "",
                    round: "",
                    dense: ""
                  }, null, 512), [
                    [W]
                  ])
                ]),
                _: 1
              }),
              b("div", Ka, [
                w(R, { class: "dialog-title" }, {
                  default: h(() => [
                    K(O(p.value ? "Login successful" : "Verify password"), 1)
                  ]),
                  _: 1
                }),
                p.value ? (T(), F(R, {
                  key: 0,
                  class: "row justify-center items-center q-py-none q-px-none q-pb-lg"
                }, {
                  default: h(() => [...P[4] || (P[4] = [
                    b("img", {
                      src: Yt,
                      alt: "",
                      srcset: "",
                      style: { width: "48px", height: "48px" }
                    }, null, -1)
                  ])]),
                  _: 1
                })) : ne("", !0),
                w(R, { class: "dialog-des" }, {
                  default: h(() => [
                    K(O(p.value ? `You have successfully logged in, and your account has been linked to ${_.value.platform}. In the future, you can log in using ${_.value.platform} or your email.` : `The email ${_.value.email} is already registered with Momcozy. Is this the email you are using? If so,
          please enter your Momcozy account password to link your ${_.value.platform} account.`), 1)
                  ]),
                  _: 1
                }),
                p.value ? ne("", !0) : (T(), F(Z, {
                  key: 1,
                  class: "text-center q-pa-none"
                }, {
                  default: h(() => [
                    w(S, {
                      ref_key: "formRef",
                      ref: c,
                      class: "full-width",
                      onSubmit: D(y, ["prevent"])
                    }, {
                      default: h(() => [
                        w(E, {
                          modelValue: o.value.password,
                          "onUpdate:modelValue": P[2] || (P[2] = (Y) => o.value.password = Y),
                          rules: C.password,
                          type: n.value,
                          label: "* Password",
                          class: "q-pb-lg",
                          outlined: ""
                        }, {
                          append: h(() => [
                            w(k, {
                              class: "cursor-pointer",
                              name: n.value === "password" ? "hide_password" : "show_password",
                              onClick: P[0] || (P[0] = (Y) => n.value = n.value === "password" ? "text" : "password")
                            }, null, 8, ["name"]),
                            b("span", {
                              class: "cursor-pointer",
                              onClick: P[1] || (P[1] = (Y) => n.value = n.value === "password" ? "text" : "password")
                            }, [
                              n.value === "password" ? (T(), H("svg", Wa, [...P[5] || (P[5] = [
                                b("g", { id: "Frame" }, [
                                  b("path", {
                                    id: "Ellipse 79",
                                    d: "M13.907 5C12.4401 6.66563 10.2728 7.71945 7.85489 7.71945C5.43701 7.71945 3.26966 6.66563 1.80273 5",
                                    stroke: "#97999B",
                                    "stroke-width": "1.3",
                                    "stroke-linecap": "round"
                                  }),
                                  b("path", {
                                    id: "Vector 8",
                                    d: "M7.35 11.5C7.35 11.859 7.64101 12.15 8 12.15C8.35899 12.15 8.65 11.859 8.65 11.5H7.35ZM8.65 8.5V7.85H7.35V8.5H8.65ZM8.65 11.5V8.5H7.35V11.5H8.65Z",
                                    fill: "#97999B"
                                  }),
                                  b("path", {
                                    id: "Vector 9",
                                    d: "M12.9371 10.9231C13.1166 11.234 13.5141 11.3405 13.825 11.161C14.1359 10.9815 14.2424 10.584 14.0629 10.2731L12.9371 10.9231ZM12.5629 7.675L12.2379 7.11208L11.1121 7.76208L11.4371 8.325L12.5629 7.675ZM14.0629 10.2731L12.5629 7.675L11.4371 8.325L12.9371 10.9231L14.0629 10.2731Z",
                                    fill: "#97999B"
                                  }),
                                  b("path", {
                                    id: "Vector 10",
                                    d: "M2.81292 10.9231C2.63342 11.234 2.23589 11.3405 1.925 11.161C1.61411 10.9815 1.50759 10.584 1.68708 10.2731L2.81292 10.9231ZM3.18708 7.675L3.51208 7.11208L4.63792 7.76208L4.31292 8.325L3.18708 7.675ZM1.68708 10.2731L3.18708 7.675L4.31292 8.325L2.81292 10.9231L1.68708 10.2731Z",
                                    fill: "#97999B"
                                  })
                                ], -1)
                              ])])) : (T(), H("svg", Ja, [...P[6] || (P[6] = [
                                b("g", {
                                  id: "Frame",
                                  "clip-path": "url(#clip0_1844_7198)"
                                }, [
                                  b("g", { id: "Intersect" }, [
                                    b("mask", {
                                      id: "path-1-inside-1_1844_7198",
                                      fill: "white"
                                    }, [
                                      b("path", {
                                        "fill-rule": "evenodd",
                                        "clip-rule": "evenodd",
                                        d: "M0.498047 8.76838C1.30429 4.69775 4.95296 1.625 9.33212 1.625C13.7193 1.625 17.3733 4.709 18.1706 8.79073C17.3644 12.8614 13.7157 15.9341 9.33652 15.9341C4.94934 15.9341 1.29534 12.8501 0.498047 8.76838Z"
                                      })
                                    ]),
                                    b("path", {
                                      d: "M0.498047 8.76838L-0.777181 8.51581L-0.826862 8.76664L-0.77784 9.0176L0.498047 8.76838ZM18.1706 8.79073L19.4458 9.0433L19.4955 8.79247L19.4465 8.54151L18.1706 8.79073ZM1.77327 9.02096C2.45817 5.56296 5.5696 2.925 9.33212 2.925V0.325C4.33631 0.325 0.150401 3.83254 -0.777181 8.51581L1.77327 9.02096ZM9.33212 2.925C13.1016 2.925 16.2174 5.57264 16.8947 9.03995L19.4465 8.54151C18.5292 3.84537 14.337 0.325 9.33212 0.325V2.925ZM16.8954 8.53815C16.2105 11.9961 13.099 14.6341 9.33652 14.6341V17.2341C14.3323 17.2341 18.5182 13.7266 19.4458 9.0433L16.8954 8.53815ZM9.33652 14.6341C5.56707 14.6341 2.45121 11.9865 1.77393 8.51916L-0.77784 9.0176C0.139468 13.7137 4.33161 17.2341 9.33652 17.2341V14.6341Z",
                                      fill: "#97999B",
                                      mask: "url(#path-1-inside-1_1844_7198)"
                                    })
                                  ]),
                                  b("circle", {
                                    id: "Ellipse 77",
                                    cx: "9.5",
                                    cy: "8.82617",
                                    r: "2.725",
                                    stroke: "#97999B",
                                    "stroke-width": "1.3"
                                  })
                                ], -1),
                                b("defs", null, [
                                  b("clipPath", { id: "clip0_1844_7198" }, [
                                    b("rect", {
                                      width: "18",
                                      height: "18",
                                      fill: "white",
                                      transform: "translate(0.5 0.5)"
                                    })
                                  ])
                                ], -1)
                              ])]))
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules", "type"]),
                        b("div", es, [
                          b("a", {
                            href: r(zt),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            "aria-label": "forget password (opens in a new tab)",
                            "aria-describedby": "a11y-new-window-message"
                          }, O(r(s)("login.actions.forgotPassword")), 9, ts)
                        ]),
                        b("div", os, [
                          w(j, {
                            loading: l.value,
                            size: "lg",
                            class: "full-width",
                            label: "Confirm",
                            type: "submit",
                            color: "dark"
                          }, null, 8, ["loading"])
                        ])
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                })),
                p.value ? (T(), H("div", {
                  key: 2,
                  class: qe(["btn-group", { success: p.value }])
                }, [
                  w(j, {
                    loading: l.value,
                    size: "lg",
                    class: "full-width",
                    label: "Confirm",
                    type: "submit",
                    color: "dark",
                    onClick: y
                  }, null, 8, ["loading"])
                ], 2)) : ne("", !0)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}, as = /* @__PURE__ */ oe(ns, [["__scopeId", "data-v-c2f9d40a"]]);
(function(e) {
  if (typeof e > "u")
    throw new Error("Geetest requires browser environment");
  var t = e.document, a = e.Math, s = t.getElementsByTagName("head")[0], i = 1e4;
  function l(u) {
    this._obj = u;
  }
  l.prototype = {
    _each: function(u) {
      var L = this._obj;
      for (var f in L)
        L.hasOwnProperty(f) && u(f, L[f]);
      return this;
    },
    _extend: function(u) {
      var L = this;
      new l(u)._each(function(f, v) {
        L._obj[f] = v;
      });
    }
  };
  var c = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(u) {
      var L = a.random() * 16 | 0, f = u === "x" ? L : L & 3 | 8;
      return f.toString(16);
    });
  };
  function o(u) {
    var L = this;
    new l(u)._each(function(f, v) {
      L[f] = v;
    });
  }
  o.prototype = {
    apiServers: ["gcaptcha4.geetest.com", "gcaptcha4.geevisit.com", "gcaptcha4.gsensebot.com"],
    staticServers: ["static.geetest.com", "static.geevisit.com"],
    protocol: "http://",
    typePath: "/load",
    fallback_config: {
      bypass: {
        staticServers: ["static.geetest.com", "static.geevisit.com"],
        type: "bypass",
        bypass: "/v4/bypass.js"
      }
    },
    _get_fallback_config: function() {
      var u = this;
      return p(u.type) ? u.fallback_config[u.type] : u.fallback_config.bypass;
    },
    _extend: function(u) {
      var L = this;
      new l(u)._each(function(f, v) {
        L[f] = v;
      });
    }
  };
  var d = function(u) {
    return typeof u == "number";
  }, p = function(u) {
    return typeof u == "string";
  }, n = function(u) {
    return typeof u == "boolean";
  }, _ = function(u) {
    return typeof u == "object" && u !== null;
  }, C = function(u) {
    return typeof u == "function";
  }, m = /Mobi/i.test(navigator.userAgent), y = {}, M = {}, A = function() {
    return parseInt(a.random() * 1e4) + (/* @__PURE__ */ new Date()).valueOf();
  }, P = function(u, L) {
    if (typeof u == "function") {
      var f = Array.prototype.slice.call(arguments, 2);
      return Function.prototype.bind ? u.bind(L, f) : function() {
        var v = Array.prototype.slice.call(arguments);
        return u.apply(L, f.concat(v));
      };
    }
  }, N = Object.prototype.toString, j = function(u) {
    return typeof u == "function";
  }, R = function(u) {
    return u === Object(u);
  }, k = function(u) {
    return N.call(u) == "[object Array]";
  }, E = function(u) {
    return N.call(u) == "[object Date]";
  }, S = function(u) {
    return N.call(u) == "[object RegExp]";
  }, Z = function(u) {
    return N.call(u) == "[object Boolean]";
  };
  function z(u) {
    return u.replace(/(\S)(_([a-zA-Z]))/g, function(L, f, v, V) {
      return f + V.toUpperCase() || "";
    });
  }
  function B(u, L) {
    if (!R(u) || E(u) || S(u) || Z(u) || j(u))
      return L ? z(u) : u;
    if (k(u))
      for (var f = [], v = 0; v < u.length; v++)
        f.push(B(u[v]));
    else {
      var f = {};
      for (var V in u)
        u.hasOwnProperty(V) && (f[B(V, !0)] = B(u[V]));
    }
    return f;
  }
  var W = function(u, L, f) {
    var v = t.createElement("script");
    v.charset = "UTF-8", v.async = !0, /static\.geetest\.com/g.test(u) && (v.crossOrigin = "anonymous"), v.onerror = function() {
      L(!0), V = !0;
    };
    var V = !1;
    v.onload = v.onreadystatechange = function() {
      !V && (!v.readyState || v.readyState === "loaded" || v.readyState === "complete") && (V = !0, setTimeout(function() {
        L(!1);
      }, 0));
    }, v.src = u, s.appendChild(v), setTimeout(function() {
      V || (v.onerror = v.onload = null, v.remove && v.remove(), L(!0));
    }, f || i);
  }, Y = function(u) {
    return u.replace(/^https?:\/\/|\/$/g, "");
  }, I = function(u) {
    return u = u && u.replace(/\/+/g, "/"), u.indexOf("/") !== 0 && (u = "/" + u), u;
  }, g = function(u) {
    if (!u)
      return "";
    var L = "?";
    return new l(u)._each(function(f, v) {
      (p(v) || d(v) || n(v)) && (L = L + encodeURIComponent(f) + "=" + encodeURIComponent(v) + "&");
    }), L === "?" && (L = ""), L.replace(/&$/, "");
  }, U = function(u, L, f, v) {
    L = Y(L);
    var V = I(f) + g(v);
    return L && (V = u + L + V), V;
  }, q = function(u, L, f, v, V, $, ee) {
    var le = function(se) {
      if (ee) {
        var re = "geetest_" + A();
        e[re] = P(ee, null, re), V.callback = re;
      }
      var ve = U(L, f[se], v, V);
      W(ve, function(Qe) {
        if (Qe) {
          if (re)
            try {
              e[re] = function() {
                e[re] = null;
              };
            } catch {
            }
          se >= f.length - 1 ? $(!0) : le(se + 1);
        } else
          $(!1);
      }, u.timeout);
    };
    le(0);
  }, J = function(u, L, f, v) {
    var V = function($, ee) {
      ee.status == "success" ? v(ee.data) : (ee.status, v(ee)), e[$] = void 0;
      try {
        delete e[$];
      } catch {
      }
    };
    q(f, f.protocol, u, L, {
      callback: "",
      captcha_id: f.captchaId,
      challenge: f.challenge || c(),
      client_type: f.clientType ? f.clientType : m ? "h5" : "web",
      risk_type: f.riskType,
      user_info: f.userInfo,
      call_type: f.callType,
      lang: f.language ? f.language : navigator.appName === "Netscape" ? navigator.language.toLowerCase() : navigator.userLanguage.toLowerCase()
    }, function($) {
      if ($ && typeof f.offlineCb == "function") {
        f.offlineCb();
        return;
      }
      $ && v(f._get_fallback_config());
    }, V);
  }, ae = function(u, L, f) {
    var v = {
      networkError: "缃戠粶閿欒",
      gtTypeError: "gt瀛楁涓嶆槸瀛楃涓茬被鍨�"
    };
    if (typeof L.onError == "function")
      L.onError({
        desc: f.desc,
        msg: f.msg,
        code: f.code
      });
    else
      throw new Error(v[u]);
  }, Ge = function() {
    return e.Geetest || t.getElementById("gt_lib");
  };
  Ge() && (M.slide = "loaded");
  var De = function(u) {
    var L = !1, f = { js: "script", css: "link" }, v = u && f[u.split(".").pop()];
    if (v !== void 0) {
      var V = t.getElementsByTagName(v);
      for (var $ in V)
        (V[$].href && V[$].href.toString().indexOf(u) > 0 || V[$].src && V[$].src.toString().indexOf(u) > 0) && (L = !0);
    }
    return L;
  };
  e.initGeetest4 = function(u, L) {
    var f = new o(u);
    u.https ? f.protocol = "https://" : u.protocol || (f.protocol = e.location.protocol + "//"), _(u.getType) && f._extend(u.getType), J(f.apiServers, f.typePath, f, function(V) {
      var V = B(V);
      if (V.status === "error")
        return ae("networkError", f, V);
      var $ = V.type;
      f.debug && new l(V)._extend(f.debug);
      var ee = function() {
        f._extend(V), L(new e.Geetest4(f));
      };
      y[$] = y[$] || [];
      var le = M[$] || "init";
      if (le === "init")
        M[$] = "loading", y[$].push(ee), V.gctPath && q(f, f.protocol, Object.hasOwnProperty.call(f, "staticServers") ? f.staticServers : V.staticServers || f.staticServers, V.gctPath, null, function(se) {
          se && ae("networkError", f, {
            code: "60205",
            msg: "Network failure",
            desc: {
              detail: "gct resource load timeout"
            }
          });
        }), q(f, f.protocol, Object.hasOwnProperty.call(f, "staticServers") ? f.staticServers : V.staticServers || f.staticServers, V.bypass || V.staticPath + V.js, null, function(se) {
          if (se)
            M[$] = "fail", ae("networkError", f, {
              code: "60204",
              msg: "Network failure",
              desc: {
                detail: "js resource load timeout"
              }
            });
          else {
            M[$] = "loaded";
            for (var re = y[$], ve = 0, Qe = re.length; ve < Qe; ve = ve + 1) {
              var ze = re[ve];
              C(ze) && ze();
            }
            y[$] = [], M[$] = "init";
          }
        });
      else {
        if (le === "loaded")
          return V.gctPath && !De(V.gctPath) && q(f, f.protocol, Object.hasOwnProperty.call(f, "staticServers") ? f.staticServers : V.staticServers || f.staticServers, V.gctPath, null, function(se) {
            se && ae("networkError", f, {
              code: "60205",
              msg: "Network failure",
              desc: {
                detail: "gct resource load timeout"
              }
            });
          }), ee();
        le === "fail" ? ae("networkError", f, {
          code: "60204",
          msg: "Network failure",
          desc: {
            detail: "js resource load timeout"
          }
        }) : le === "loading" && y[$].push(ee);
      }
    });
  };
})(window);
const Ze = Jt || globalThis.Quasar, Se = /* @__PURE__ */ Symbol.for("login-element-instance"), xe = /* @__PURE__ */ Symbol.for("third-verify-password-element-instance"), Le = /* @__PURE__ */ Symbol.for("third-login-complete-info-element-instance"), Te = /* @__PURE__ */ Symbol.for("quick-register-member-element-instance"), ss = Ae(Ma, {
  configureApp(e) {
    e.use(Ze, {
      config: {
        brand: {
          primary: "#6f3b49",
          positive: "#71BF89",
          dark: "#1F1F20",
          negative: "#FA5151"
        },
        globalNodes: {
          class: "quasar"
        }
      },
      plugins: {
        Notify: be,
        Loading: st
      }
    }), e.provide(Fe, de), e.use(de);
  }
});
class rs extends ss {
  connectedCallback() {
    const t = window[Se];
    t && t !== this && document.contains(t) && this.remove(), window[Se] = this, super.connectedCallback();
  }
  disconnectedCallback() {
    window[Se] === this && (window[Se] = null), super.disconnectedCallback();
  }
}
customElements.get("login-dialog") || customElements.define("login-dialog", rs);
const is = Ae(as, {
  configureApp(e) {
    e.use(Ze, {
      config: {
        brand: {
          primary: "#6f3b49",
          positive: "#71BF89",
          dark: "#1F1F20",
          negative: "#FA5151"
        },
        globalNodes: {
          class: "quasar"
        }
      },
      plugins: {
        Notify: be,
        Loading: st
      }
    }), e.provide(Fe, de), e.use(de);
  }
});
class ls extends is {
  connectedCallback() {
    const t = window[xe];
    t && t !== this && document.contains(t) && this.remove(), window[xe] = this, super.connectedCallback();
  }
  disconnectedCallback() {
    window[xe] === this && (window[xe] = null), super.disconnectedCallback();
  }
}
customElements.get("third-verify-password-dialog") || customElements.define("third-verify-password-dialog", ls);
const cs = Ae(Xa, {
  configureApp(e) {
    e.use(Ze, {
      config: {
        brand: {
          primary: "#6f3b49",
          positive: "#71BF89",
          dark: "#1F1F20",
          negative: "#FA5151"
        },
        globalNodes: {
          class: "quasar"
        }
      },
      plugins: {
        Notify: be,
        Loading: st
      }
    }), e.provide(Fe, de), e.use(de);
  }
});
class us extends cs {
  connectedCallback() {
    const t = window[Le];
    t && t !== this && document.contains(t) && this.remove(), window[Le] = this, super.connectedCallback();
  }
  disconnectedCallback() {
    window[Le] === this && (window[Le] = null), super.disconnectedCallback();
  }
}
customElements.get("third-login-complete-info-dialog") || customElements.define("third-login-complete-info-dialog", us);
const ds = Ae(Ga, {
  configureApp(e) {
    e.use(Ze, {
      config: {
        brand: {
          primary: "#6f3b49",
          positive: "#71BF89",
          dark: "#1F1F20",
          negative: "#FA5151"
        },
        globalNodes: {
          class: "quasar"
        }
      },
      plugins: {
        Notify: be
      }
    }), e.provide(Fe, de), e.use(de);
  }
});
class fs extends ds {
  connectedCallback() {
    const t = window[Te];
    t && t !== this && document.contains(t) && this.remove(), window[Te] = this, super.connectedCallback();
  }
  disconnectedCallback() {
    window[Te] === this && (window[Te] = null), super.disconnectedCallback();
  }
}
customElements.get("quick-register-member-dialog") || customElements.define("quick-register-member-dialog", fs);
